/* Yerba visual product behaviour (product-awc-3-visual).
   Moved out of the snippet so browsers cache and code-cache it. Per-section
   settings and product data are printed by the snippet into
   window.yvVisualProducts[sectionId] just before this file is loaded. */
(() => {
/* Image data is sent as one 1000px URL; the other sizes use the same URL
   with a different width parameter, exactly as image_url would print them. */
const yvWidthUrl = (url, width) => (url ? url.replace(/([?&])width=\d+/, `$1width=${width}`) : url);
const yvSrcset = (url, widths) => widths.map((width) => `${yvWidthUrl(url, width)} ${width}w`).join(', ');

const initYerbaVisualProduct = (root) => {
if (!root || root.dataset.yvInitialized === 'true') return;
const yvSectionId = root.dataset.wethemeSectionId;
const yvData = window.yvVisualProducts && window.yvVisualProducts[yvSectionId];
if (!yvData) return;
root.dataset.yvInitialized = 'true';
const yvConfig = yvData.config;

const normalize = (value) => (value || '').toString().trim().replace(/\s+/g, ' ').toLowerCase();
const colorSource = yvConfig.colorSource;
const fallbackMediaBackground = yvConfig.fallbackMediaBackground;
const optionIndex = yvConfig.optionIndex;
const variantHeadingTitles = new Map(Array.from(
root.querySelector('[data-yv-heading-titles]')?.content.querySelectorAll('[data-heading-title]') || [],
(title) => [title.dataset.optionValue, title.dataset.headingTitle]
));
const cartPermalinkBase = yvConfig.cartPermalinkBase;
const cartPageUrl = yvConfig.cartPageUrl;
const checkoutUrl = yvConfig.checkoutUrl;
const cartAddUrl = yvConfig.cartAddUrl;
const cartJsonUrl = yvConfig.cartJsonUrl;
const cartUpdateUrl = yvConfig.cartUpdateUrl;
const cartChangeUrl = yvConfig.cartChangeUrl;
const moneyFormat = yvConfig.moneyFormat;
const moneyFormatPlaceholder = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
const plainTextDecoder = document.createElement('span');
const shouldUseCartDrawer = root.dataset.cartType === 'drawer';
const shouldEstimateCartDiscount = root.dataset.estimatedCartDiscountEnabled === 'true';
const couponTestVariantId = root.dataset.couponTestVariantId || '';
const couponProbePropertyName = '_yerba_coupon_probe';
const awcPurchaseModePropertyName = '_awc_purchase_mode';
const awcPurchaseModeValue = 'quantity_selector';
const couponCodeRequiredAddLabel = 'ADD TO CART (CODE REQUIRED)';
const appstleReturnContextPropertyName = '_awc_appstle_return_context';
const appstleReturnContextStoragePrefix = 'yerba:appstle-return-context:';
const discountCodeCookieName = 'discount_code';
const couponEligibilityStorageKey = 'yerba:newsletter-coupon-eligible';
const parseDiscountPercent = (value) => {
const percent = Number.parseFloat(value || '0');
return Number.isFinite(percent) && percent > 0 ? Math.min(100, percent) : 0;
};
const estimatedCartDiscountPercent = shouldEstimateCartDiscount
? parseDiscountPercent(root.dataset.estimatedCartDiscountPercent)
: 0;
let cartDiscountPercent = parseDiscountPercent(root.dataset.initialCartDiscountPercent);
let cartDiscountCode = (root.dataset.initialCartDiscountCode || '').trim();
let activeDiscountPercent = 0;
let activeDiscountCode = '';
const couponKlaviyoFormIds = (root.dataset.couponKlaviyoFormIds || '')
.split(',')
.map((id) => id.trim())
.filter(Boolean);
let couponRequestPromise = null;
let lastCookieDiscountCodeSync = '';
let isSubmittingAfterCookieDiscountSync = false;

const normalizeDiscountCode = (value) => (value || '').toString().trim();

const discountCodesMatch = (firstCode, secondCode) => {
return normalizeDiscountCode(firstCode).toLowerCase() === normalizeDiscountCode(secondCode).toLowerCase();
};

const decodeCookieValue = (value) => {
try {
return decodeURIComponent((value || '').replace(/\+/g, ' '));
} catch (error) {
return value || '';
}
};

const getCookieValue = (name) => {
const cookieName = `${name}=`;
const cookies = (document.cookie || '').split(';');

for (const cookie of cookies) {
const trimmedCookie = cookie.trim();
if (trimmedCookie.indexOf(cookieName) === 0) {
  return decodeCookieValue(trimmedCookie.slice(cookieName.length));
}
}

return '';
};

const getDiscountCodeFromCookie = () => normalizeDiscountCode(getCookieValue(discountCodeCookieName));

const clearCookie = (name) => {
const hostname = window.location.hostname;
const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
const cookieBase = `${name}=; expires=${expires}; max-age=0; path=/`;

document.cookie = cookieBase;

if (hostname) {
document.cookie = `${cookieBase}; domain=${hostname}`;
document.cookie = `${cookieBase}; domain=.${hostname}`;

const parts = hostname.split('.');
if (parts.length > 2) {
  document.cookie = `${cookieBase}; domain=.${parts.slice(-2).join('.')}`;
}
}
};

const markCouponEligibleForSession = () => {
try {
window.sessionStorage.setItem(couponEligibilityStorageKey, 'true');
} catch (error) {
}
};

const getRememberedDiscountState = () => {
if (!window.YerbaDiscountState) {
return {
  percent: 0,
  code: ''
};
}

const state = window.YerbaDiscountState.read();
return {
percent: parseDiscountPercent(state && state.percent),
code: (state && state.code || '').trim()
};
};

const shouldDefaultToCouponPurchaseMode = () => {
/* ?coupon-code in the product URL (with or without a value) opens the Coupon Modality first. */
try {
if (new URLSearchParams(window.location.search).has('coupon-code')) return true;
} catch (error) {
}

if (root.dataset.customerCouponEligible === 'true') return true;

try {
if (window.sessionStorage.getItem(couponEligibilityStorageKey) === 'true') return true;
} catch (error) {
}

if (getDiscountCodeFromCookie()) return true;

const rememberedDiscountState = getRememberedDiscountState();
return rememberedDiscountState.percent > 0 && Boolean(rememberedDiscountState.code);
};

const resolveActiveDiscountState = () => {
if (cartDiscountPercent > 0) {
return {
  percent: cartDiscountPercent,
  code: cartDiscountCode
};
}

const rememberedDiscountState = getRememberedDiscountState();
if (rememberedDiscountState.percent > 0) {
return rememberedDiscountState;
}

return {
percent: 0,
code: ''
};
};

const refreshActiveDiscountState = () => {
const state = resolveActiveDiscountState();
activeDiscountPercent = state.percent;
activeDiscountCode = state.code || '';
};

const couponCodeIsRequiredForAdd = () => {
/* Shopify does not expose a discount application in cart.js while the cart is
   empty. Valid newsletter and manually entered coupons are therefore kept in
   the resolved active state after validation, including when the last cart item
   is removed. Use that same state for the button gate so the retained coupon
   does not leave ADD TO CART disabled just because the empty cart reports no
   discount. */
return root.dataset.purchaseMode === 'coupon' && activeDiscountPercent <= 0;
};

refreshActiveDiscountState();
const yvExpandImage = (item, withThumb) => {
if (!item.image) {
  item.srcset = '';
  item.zoom = null;
  item.zoomSrcset = '';
  return item;
}
item.srcset = yvSrcset(item.image, [420, 640, 820, 1000]);
item.zoom = yvWidthUrl(item.image, 1800);
item.zoomSrcset = yvSrcset(item.image, [1000, 1400, 1800, 2200]);
if (withThumb) {
  item.thumb = yvWidthUrl(item.image, 240);
  item.thumbSrcset = yvSrcset(item.image, [120, 180, 240]);
}
return item;
};
const variants = yvData.variants.map((variant) => {
yvExpandImage(variant, false);
variant.gallery.forEach((item) => yvExpandImage(item, true));
variant.mobileGallery.forEach((item) => yvExpandImage(item, true));
return variant;
});
const variantsById = new Map(variants.map((variant) => [String(variant.id), variant]));
const fallbackThumbs = yvData.fallbackThumbs.map((item) => yvExpandImage(item, true));

const colorMap = new Map();
colorSource.split(/\r?\n/).forEach((line) => {
const cleanLine = line.trim();
if (!cleanLine || cleanLine.startsWith('//') || cleanLine.startsWith('# ')) return;

const separatorIndex = cleanLine.search(/\s*[:=]\s*/);
if (separatorIndex === -1) return;

const name = cleanLine.slice(0, separatorIndex).trim();
const color = cleanLine.slice(separatorIndex).replace(/^\s*[:=]\s*/, '').trim();
if (name && color) colorMap.set(normalize(name), color);
});

const bundleFlavorFallbackColors = new Map([
['mint', '#2BD8C5'],
['mango', '#E65B50'],
['lemonade', '#FFE34D']
]);

const getColorForOption = (value) => {
const normalizedValue = normalize(value);
return colorMap.get(normalizedValue)
  || colorMap.get('*')
  || colorMap.get('default')
  || bundleFlavorFallbackColors.get(normalizedValue)
  || fallbackMediaBackground;
};

const variantSelect = root.querySelector('[data-yv-variant-select]');
const variantCards = Array.from(root.querySelectorAll('[data-yv-variant-card]'));
const mainImage = root.querySelector('.yv-main-image');
const mainVideoHost = root.querySelector('[data-yv-main-video-host]');
const videoTemplates = Array.from(root.querySelectorAll('[data-yv-video-template]'));
let mainVideo = null;
const mainCard = root.querySelector('[data-yv-main-card]');
const videoAutoplay = yvConfig.videoAutoplay;
const videoLoop = yvConfig.videoLoop;
const videoControls = yvConfig.showVideoControls || !videoAutoplay;
const lightbox = document.getElementById(`yv-lightbox-${yvSectionId}`);
if (lightbox && lightbox.parentElement !== document.body) {
document.body.appendChild(lightbox);
}
const lightboxImage = lightbox ? lightbox.querySelector('[data-yv-lightbox-image]') : null;
const lightboxCaption = lightbox ? lightbox.querySelector('[data-yv-lightbox-caption]') : null;
const lightboxCount = lightbox ? lightbox.querySelector('[data-yv-lightbox-count]') : null;
const lightboxThumbs = lightbox ? lightbox.querySelector('[data-yv-lightbox-thumbs]') : null;
const lightboxStage = lightbox ? lightbox.querySelector('[data-yv-lightbox-stage]') : null;
const lightboxFigure = lightbox ? lightbox.querySelector('.yv-lightbox-figure') : null;
const lightboxPrev = lightbox ? lightbox.querySelector('[data-yv-lightbox-prev]') : null;
const lightboxNext = lightbox ? lightbox.querySelector('[data-yv-lightbox-next]') : null;
const lightboxZoomIn = lightbox ? lightbox.querySelector('[data-yv-lightbox-zoom-in]') : null;
const lightboxZoomOut = lightbox ? lightbox.querySelector('[data-yv-lightbox-zoom-out]') : null;
const lightboxZoomReset = lightbox ? lightbox.querySelector('[data-yv-lightbox-zoom-reset]') : null;
const lightboxCloseButtons = lightbox ? Array.from(lightbox.querySelectorAll('[data-yv-lightbox-close]')) : [];
const thumbFrame = root.querySelector('[data-yv-thumb-frame]');
const thumbViewport = root.querySelector('[data-yv-thumb-viewport]');
const thumbRail = root.querySelector('[data-yv-thumb-rail]');
const thumbNavButtons = Array.from(root.querySelectorAll('[data-yv-thumb-page]'));
let thumbs = Array.from(root.querySelectorAll('[data-yv-thumb]'));
let activeGalleryItems = [];
let lightboxItems = [];
let lightboxIndex = 0;
let lightboxPreviouslyFocused = null;
let mainCardShouldIgnoreClick = false;
let desktopThumbStart = 0;
let desktopVisibleThumbs = 0;
let mobileThumbStart = 0;
let mobileVisibleThumbs = 0;
const selectedTitle = root.querySelector('[data-yv-selected-title]');
const selectedDescription = root.querySelector('[data-yv-selected-description]');
const selectedDescriptionDesktop = root.querySelector('[data-yv-selected-description-desktop]');
const selectedDescriptionMobile = root.querySelector('[data-yv-selected-description-mobile]');
const showcase = root.querySelector('[data-yv-showcase]');
const benefitVisual = root.querySelector('[data-yv-benefit-visual]');
const selectedRating = root.querySelector('.yv-rating');
const variantGroup = root.querySelector('.yv-variant-group');
const addToCart = root.querySelector('[data-yv-atc]');
const productCartItemLimit = 10;
const productCartItemLimitText = 'Cart Limit';
let currentCartItemCount = Math.max(
  0,
  Number.parseInt(root.dataset.initialCartItemCount, 10) || 0
);
const bundleStatus = root.querySelector('[data-yv-bundle-status]');
const currentPrice = root.querySelector('[data-yv-current-price]');
let expectedCouponPriceText = '';
if (currentPrice && typeof MutationObserver === 'function') {
  new MutationObserver(() => {
    if (
      root.dataset.purchaseMode === 'coupon'
      && expectedCouponPriceText
      && currentPrice.textContent !== expectedCouponPriceText
    ) {
      currentPrice.textContent = expectedCouponPriceText;
    }
  }).observe(currentPrice, { childList: true, characterData: true, subtree: true });
}
const discountRate = root.querySelector('[data-yv-discount-rate]');
const couponForm = root.querySelector('[data-yv-coupon-form]');
const couponApplied = root.querySelector('[data-yv-coupon-applied]');
const couponInput = root.querySelector('[data-yv-coupon-input]');
const couponApply = root.querySelector('[data-yv-coupon-apply]');
const couponRemove = root.querySelector('[data-yv-coupon-remove]');
const couponCode = root.querySelector('[data-yv-coupon-code]');
const couponMessage = root.querySelector('[data-yv-coupon-message]');
const modeToggle = root.querySelector('[data-yv-mode-toggle]');
const modeToggleLabel = root.querySelector('[data-yv-mode-toggle-label]');

const cartConflict = document.createElement('p');
cartConflict.className = 'yv-cart-conflict';
cartConflict.hidden = true;
cartConflict.setAttribute('role', 'alert');
cartConflict.setAttribute('aria-live', 'polite');
const cartConflictPrefix = document.createElement('span');
const cartConflictClear = document.createElement('button');
cartConflictClear.className = 'yv-cart-conflict__clear';
cartConflictClear.type = 'button';
cartConflictClear.textContent = 'CLEAR';
const cartConflictSuffix = document.createElement('span');
cartConflict.append(cartConflictPrefix, cartConflictClear, cartConflictSuffix);
if (addToCart) addToCart.insertAdjacentElement('afterend', cartConflict);

let cartPurchaseConflictState = {
  coupon: Boolean(root.dataset.initialCartDiscountCode)
    || Number.parseFloat(root.dataset.initialCartDiscountPercent || '0') > 0,
  volume: root.dataset.initialCartHasVolume === 'true'
};
let cartClearInFlight = false;

const cartHasVolumeDiscount = (cart) => {
  return (cart && cart.items || []).some((item) => {
    const properties = item && item.properties || {};
    return normalize(properties._appstle_bundles_type) === 'volume_discount'
      || Boolean(properties['_appstle-bb-id']);
  });
};

const syncCartPurchaseConflictState = () => {
  const isCouponMode = root.dataset.purchaseMode === 'coupon';
  const isBlocked = isCouponMode
    ? cartPurchaseConflictState.volume
    : cartPurchaseConflictState.coupon;

  cartConflict.hidden = !isBlocked;
  if (isBlocked) {
    cartConflictPrefix.textContent = isCouponMode
      ? 'Volume discount detected in cart! '
      : 'Coupon Code detected in cart! ';
    cartConflictSuffix.textContent = isCouponMode
      ? ' your cart before using a coupon.'
      : ' your cart before using a volume discount.';
  }
  return isBlocked;
};

const updateCartPurchaseConflictState = (cart) => {
  currentCartItemCount = Math.max(0, Number.parseInt(cart && cart.item_count, 10) || 0);
  cartPurchaseConflictState = {
    coupon: getDiscountApplications(cart).some(isProductCouponDiscountApplication),
    volume: cartHasVolumeDiscount(cart)
  };
  syncCartPurchaseConflictState();
};

cartConflictClear.addEventListener('click', async () => {
  if (cartClearInFlight) return;
  cartClearInFlight = true;
  cartConflictClear.disabled = true;
  cartConflict.setAttribute('aria-busy', 'true');
  try {
    const clearResponse = await fetch(`${cartPageUrl}/clear.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    if (!clearResponse.ok) throw new Error('Unable to clear cart');
    await updateDiscountCodes('');
    const cart = await fetchCartJson();
    if (window.YerbaDiscountState) {
      window.YerbaDiscountState.clear({ source: 'product-clear-conflict', silent: true });
    }
    clearCookie(discountCodeCookieName);
    cartDiscountPercent = 0;
    cartDiscountCode = '';
    activeDiscountPercent = 0;
    activeDiscountCode = '';
    updateCartDiscountState(cart);
    updateCartQuantityDisplay(cart);
    dispatchCartUpdated(cart, {});
  } catch (error) {
    console.warn(error);
  } finally {
    cartClearInFlight = false;
    cartConflictClear.disabled = false;
    cartConflict.removeAttribute('aria-busy');
  }
});

['cart:updated', 'theme:cart:updated', 'ajaxCart:updated'].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    const cart = event.detail && event.detail.cart;
    if (cart) {
      updateCartDiscountState(cart);
    } else {
      refreshCartDiscountState();
    }
  });
});

const primaryButtonPriceSuffixPattern = /\s*\|\s*[\$£€¥\d\.,\s]+$/i;
const normalizePrimaryButtonText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
let primaryButtonBaseLabel = root.dataset.addLabel || 'Add to Cart';
let primaryButtonPriceText = '';

const renderPrimaryButtonLabel = (label) => {
  if (!addToCart || !label) return;

  let labelEl = addToCart.querySelector('[data-yv-atc-label]');
  const fullButtonText = normalizePrimaryButtonText(addToCart.textContent);

  // Appstle can append the price in a separate text node or element. Rebuild
  // the label so only our configured order total remains in either mode.
  if (!labelEl || fullButtonText !== label) {
    labelEl = document.createElement('span');
    labelEl.className = 'yv-atc-label';
    labelEl.setAttribute('data-yv-atc-label', '');
    labelEl.textContent = label;
    addToCart.replaceChildren(labelEl);
    return;
  }

  if (labelEl.textContent !== label) labelEl.textContent = label;
};

const setPrimaryButtonLabel = (label) => {
  if (!addToCart) return;
  const baseLabel = root.dataset.addLabel || 'Add to Cart';
  let normalizedLabel = String(label || baseLabel).trim();
  // Remove Appstle's suffix before adding the selected order total ourselves.
  normalizedLabel = normalizedLabel.replace(primaryButtonPriceSuffixPattern, '').trim();
  if (!normalizedLabel) normalizedLabel = baseLabel;

  primaryButtonBaseLabel = normalizedLabel;
  const showPrice = root.dataset.priceDisplay === 'add_to_cart'
    && normalizedLabel === baseLabel
    && primaryButtonPriceText;
  const renderedLabel = showPrice ? `${normalizedLabel} - ${primaryButtonPriceText}` : normalizedLabel;
  addToCart.dataset.yvButtonLabel = renderedLabel;
  addToCart.setAttribute('aria-label', renderedLabel);
  renderPrimaryButtonLabel(renderedLabel);
};

const sanitizeButtonText = () => {
  if (!addToCart) return;
  const expectedLabel = String(addToCart.dataset.yvButtonLabel || '').trim();
  const currentText = normalizePrimaryButtonText(addToCart.textContent);
  const sanitizedText = currentText
    .replace(primaryButtonPriceSuffixPattern, '')
    .trim();
  const nextLabel = expectedLabel || sanitizedText;
  if (nextLabel && currentText !== nextLabel) renderPrimaryButtonLabel(nextLabel);
};
const atcObserver = new MutationObserver(sanitizeButtonText);
if (addToCart) {
  atcObserver.observe(addToCart, { childList: true, characterData: true, subtree: true });
}

const getFlavorColor = (flavorName, variantId) => {
  const name = String(flavorName || '').toLowerCase();
  if (name.includes('mango') || String(variantId) === '48890874134778') return '#EF4643';
  if (name.includes('lemonade') || String(variantId) === '48890874167546') return '#FFDE17';
  if (name.includes('variety') || String(variantId) === '48890874233082') return '#41CBF1';
  return '#29EFCE'; // Mint / Default
};

const getMobileForegroundColor = (flavorName, variantId) => {
  const name = String(flavorName || '').toLowerCase();
  return name.includes('mango') || String(variantId) === '48890874134778'
    ? '#062A19'
    : '#0B5231';
};

const updateBundleOptionQuantityCopy = (bundleOption) => {
  if (!bundleOption) return;
  const quantity = getBundleOptionQuantity(bundleOption);
  const titleQuantity = bundleOption.querySelector('[data-yv-bundle-title-quantity]');
  const titleUnit = bundleOption.querySelector('[data-yv-bundle-title-unit]');
  const stickCount = bundleOption.querySelector('[data-yv-bundle-stick-count]');
  const quantityValue = bundleOption.querySelector('[data-yv-bundle-quantity-value]');
  const decreaseButton = bundleOption.querySelector('[data-yv-bundle-quantity-change="-1"]');
  const increaseButton = bundleOption.querySelector('[data-yv-bundle-quantity-change="1"]');

  if (titleQuantity) titleQuantity.textContent = String(quantity);
  if (titleUnit) titleUnit.textContent = quantity === 1 ? 'Set' : 'Sets';
  if (stickCount) stickCount.textContent = String(quantity * yvConfig.stickPacksPerBag);
  if (quantityValue) quantityValue.textContent = String(quantity);
  if (decreaseButton) decreaseButton.disabled = quantity <= 1;
  if (increaseButton) {
    const cartLimitReached = currentCartItemCount + quantity >= productCartItemLimit;
    increaseButton.disabled = cartLimitReached;
    if (cartLimitReached) increaseButton.setAttribute('aria-disabled', 'true');
    else increaseButton.removeAttribute('aria-disabled');
  }
};

const createAdditionalBundleFlavorRow = (bundleOption, slotNumber) => {
  const rows = Array.from(bundleOption.querySelectorAll('.yv-bundle-flavor-row'));
  const sourceRow = rows[rows.length - 1];
  if (!sourceRow) return null;

  const row = sourceRow.cloneNode(true);
  const label = row.querySelector('.yv-bundle-flavor-label');
  const select = row.querySelector('[data-yv-bundle-flavor-select]');
  if (!select) return null;

  const selectId = `yerba-bundle-flavor-${yvSectionId}-dynamic-${slotNumber}`;
  if (label) {
    label.textContent = `#${slotNumber}`;
    label.setAttribute('for', selectId);
  }
  select.id = selectId;
  select.setAttribute('aria-label', `Flavor for set ${slotNumber}`);
  select.disabled = false;

  const sourceSelect = sourceRow.querySelector('[data-yv-bundle-flavor-select]');
  const preferredVariantId = String(
    sourceSelect && sourceSelect.value
    || variantSelect && variantSelect.value
    || yvConfig.currentVariantId
  );
  if (Array.from(select.options).some((option) => String(option.value) === preferredVariantId)) {
    select.value = preferredVariantId;
  }

  bundleFlavorSelects.push(select);
  updateBundleFlavorColor(select);
  return row;
};

const setBundleOptionQuantity = (bundleOption, requestedQuantity) => {
  if (!bundleOption) return;
  const minimumQuantity = 1;
  const maximumQuantity = Math.max(
    minimumQuantity,
    productCartItemLimit - currentCartItemCount
  );
  const nextQuantity = Math.max(
    minimumQuantity,
    Math.min(maximumQuantity, Number.parseInt(requestedQuantity, 10) || minimumQuantity)
  );
  const flavors = bundleOption.querySelector('.yv-bundle-flavors');
  if (!flavors) return;

  let rows = Array.from(flavors.querySelectorAll('.yv-bundle-flavor-row'));
  while (rows.length < nextQuantity) {
    const row = createAdditionalBundleFlavorRow(bundleOption, rows.length + 1);
    if (!row) break;
    flavors.appendChild(row);
    rows.push(row);
  }

  while (rows.length > nextQuantity && rows.length > minimumQuantity) {
    const row = rows.pop();
    const select = row.querySelector('[data-yv-bundle-flavor-select]');
    const selectIndex = bundleFlavorSelects.indexOf(select);
    if (selectIndex >= 0) bundleFlavorSelects.splice(selectIndex, 1);
    row.remove();
  }

  bundleOption.dataset.quantity = String(rows.length);
  const radio = bundleOption.querySelector('[data-yv-bundle-radio]');
  if (radio) radio.value = String(rows.length);
  updateBundleOptionQuantityCopy(bundleOption);
  syncBundleSelectionState(false);

  const variant = getSelectedVariant() || getBundleOptionVariants(bundleOption)[0];
  if (variant) updatePurchaseState(variant);
  scheduleDiscountCodeCookieSync('product-awc-quantity');
  updateMobileHeroHeight();
};

const getAppstleProductQuantityForCartLimit = (summary = null) => {
  const selectedTier = getSelectedAppstleTier();
  if (!selectedTier) return 1;

  const quantityValue = Number.parseInt(
    selectedTier.querySelector('.ab-volume-discount-tier-quantity-value')?.textContent,
    10
  );
  const flavorQuantity = getAppstleFlavorSelectsForAwc(selectedTier).length;
  const selectedTierQuantity = Number.parseInt(summary && summary.selectedTier, 10);
  const baseTierQuantity = Number.parseInt(selectedTier.dataset.yvBaseTier, 10)
    || getAppstleTierNumberForAwc(selectedTier);

  return Math.max(
    1,
    Number.isFinite(quantityValue) ? quantityValue : 0,
    flavorQuantity,
    Number.isFinite(selectedTierQuantity) ? selectedTierQuantity : 0,
    Number.isFinite(baseTierQuantity) ? baseTierQuantity : 0
  );
};

const getPendingProductQuantityForCartLimit = (summary = null) => {
  return root.dataset.purchaseMode === 'appstle'
    ? getAppstleProductQuantityForCartLimit(summary)
    : getCurrentQuantity();
};

const productCartLimitWouldBeExceeded = (summary = null) => {
  return currentCartItemCount + getPendingProductQuantityForCartLimit(summary)
    > productCartItemLimit;
};

const ensureProductCartLimitMessage = (quantityControl, type) => {
  if (!quantityControl) return null;
  const container = quantityControl.parentElement;
  if (!container) return null;

  let message = container.querySelector(
    `:scope > [data-yv-product-cart-limit="${type}"]`
  );
  if (!message) {
    message = document.createElement('p');
    message.className = `yv-product-cart-limit yv-product-cart-limit--${type}`;
    message.dataset.yvProductCartLimit = type;
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.textContent = productCartItemLimitText;
    message.hidden = true;
    quantityControl.insertAdjacentElement('afterend', message);
  }
  return message;
};

const setProductCartLimitButtonState = (button, limitReached) => {
  if (!button) return;
  if (button.disabled !== limitReached) button.disabled = limitReached;
  if (limitReached) {
    if (button.getAttribute('aria-disabled') !== 'true') {
      button.setAttribute('aria-disabled', 'true');
    }
  } else if (button.hasAttribute('aria-disabled')) {
    button.removeAttribute('aria-disabled');
  }
};

const setProductCartLimitMessageVisibility = (message, visible) => {
  if (message && message.hidden === visible) message.hidden = !visible;
};

const syncProductCartLimitControls = (summary = null) => {
  const selectedBundleOption = getSelectedBundleOption();
  bundleOptions.forEach((bundleOption) => {
    const quantity = getBundleOptionQuantity(bundleOption);
    const quantityControl = bundleOption.querySelector('.yv-bundle-quantity-control');
    const increaseButton = bundleOption.querySelector('[data-yv-bundle-quantity-change="1"]');
    const reached = currentCartItemCount + quantity >= productCartItemLimit;
    setProductCartLimitButtonState(increaseButton, reached);
    const message = ensureProductCartLimitMessage(quantityControl, 'awc');
    setProductCartLimitMessageVisibility(
      message,
      bundleOption === selectedBundleOption && reached
    );
  });

  root.querySelectorAll('.ab-volume-discount-tier-quantity-increment').forEach((button) => {
    setProductCartLimitButtonState(button, false);
  });
  root.querySelectorAll('[data-yv-product-cart-limit="appstle"]').forEach((message) => {
    setProductCartLimitMessageVisibility(message, false);
  });

  const selectedAppstleTier = getSelectedAppstleTier();
  const appstleQuantityControl = selectedAppstleTier
    ? selectedAppstleTier.querySelector('.ab-volume-discount-tier-quantity-section')
    : null;
  const appstleQuantity = getAppstleProductQuantityForCartLimit(summary);
  const appstleLimitReached = currentCartItemCount + appstleQuantity >= productCartItemLimit;
  const appstleIncreaseButton = appstleQuantityControl
    ? appstleQuantityControl.querySelector('.ab-volume-discount-tier-quantity-increment')
    : null;
  setProductCartLimitButtonState(appstleIncreaseButton, appstleLimitReached);
  const appstleMessage = ensureProductCartLimitMessage(appstleQuantityControl, 'appstle');
  setProductCartLimitMessageVisibility(
    appstleMessage,
    root.dataset.purchaseMode === 'appstle' && appstleLimitReached
  );
};

root.addEventListener('click', (event) => {
  const primaryButton = event.target.closest('[data-yv-atc], [data-yv-buy-now]');
  if (primaryButton && root.contains(primaryButton) && productCartLimitWouldBeExceeded()) {
    event.preventDefault();
    event.stopImmediatePropagation();
    syncProductCartLimitControls();
    const currentVariant = getSelectedVariant();
    if (currentVariant) updatePurchaseState(currentVariant);
    return;
  }

  const increaseButton = event.target.closest(
    '.ab-volume-discount-tier-quantity-increment, [data-yv-bundle-quantity-change="1"]'
  );
  if (!increaseButton || !root.contains(increaseButton)) return;

  const pendingQuantity = increaseButton.matches('[data-yv-bundle-quantity-change]')
    ? getBundleOptionQuantity(increaseButton.closest('[data-yv-bundle-option]'))
    : getAppstleProductQuantityForCartLimit();
  if (currentCartItemCount + pendingQuantity < productCartItemLimit) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  syncProductCartLimitControls();
}, true);

const updateMobileHeroHeight = () => {
if (window.innerWidth >= 750) return;
const heroBoundary = root.querySelector('[data-yv-showcase]');
if (!heroBoundary) return;
const sectionRect = root.getBoundingClientRect();
const boundaryRect = heroBoundary.getBoundingClientRect();
const heroHeight = Math.round(boundaryRect.bottom - sectionRect.top + 10);
if (heroHeight > 0) {
  root.style.setProperty('--yv-mobile-hero-height', `${heroHeight}px`);
}
};
window.addEventListener('resize', updateMobileHeroHeight);
window.addEventListener('orientationchange', updateMobileHeroHeight);
const bundleSelector = root.querySelector('[data-yv-bundle-selector]');
const bundleOptions = Array.from(root.querySelectorAll('[data-yv-bundle-option]'));
const bundleRadios = Array.from(root.querySelectorAll('[data-yv-bundle-radio]'));
const bundleFlavorSelects = Array.from(root.querySelectorAll('[data-yv-bundle-flavor-select]'));
const qtyInput = root.querySelector('[data-yv-qty-input]');
const buyNow = root.querySelector('[data-yv-buy-now]');
const productForm = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');

if (showcase) {
[selectedTitle, selectedRating, selectedDescription, variantGroup].forEach((element) => {
if (!element) return;
showcase.insertBefore(element, benefitVisual || null);
});
}

const appstleVolumeDiscountSelector = [
'[appstle-volume-discount-unique-reference]',
'#appstleVolumeDiscountContainer',
'.ab-volume-discount-container'
].join(', ');
const appstleVolumeWidgetReferenceSelector = [
'[appstle-volume-discount-unique-reference] [data-appstle-bundles-widget-unique-ref]',
'#appstleVolumeDiscountContainer [data-appstle-bundles-widget-unique-ref]',
'.ab-volume-discount-container [data-appstle-bundles-widget-unique-ref]'
].join(', ');
const appstleTierControlSelector = [
'.ab-volume-discount-item-container[role="radio"]',
'.ab-volume-discount-item-container-v2[role="radio"]',
'.ab-volume-discount-item-container-v3[role="radio"]',
'.ab-volume-discount-item-details-wrapper[role="radio"]'
].join(', ');
const appstleSelectedTierSelector = [
'.ab-volume-discount-item-container[role="radio"][aria-checked="true"]',
'.ab-volume-discount-item-container-v2[role="radio"][aria-checked="true"]',
'.ab-volume-discount-item-container-v3[role="radio"][aria-checked="true"]',
'.ab-volume-discount-item-details-wrapper[role="radio"][aria-checked="true"]'
].join(', ');
const appstleSubscriptionControlSelector = [
'.ab-volume-subscription-section[role="checkbox"]',
'.ab-volume-subscription-section-v2[role="radio"]',
'.ab-volume-subscription-section-v3[role="radio"]',
'.ab-volume-onetime-section-v2[role="radio"]',
'.ab-volume-onetime-section-v3[role="radio"]'
].join(', ');
const appstleSelectedSubscriptionSelector = [
'.ab-volume-subscription-section[role="checkbox"][aria-checked="true"]',
'.ab-volume-subscription-section-v2[role="radio"][aria-checked="true"]',
'.ab-volume-subscription-section-v3[role="radio"][aria-checked="true"]'
].join(', ');
let addToCartFeedbackTimeout = null;
let couponRequestInFlight = false;
let isBundleSubmitting = false;
let activePurchaseSource = 'none';
let isPurchaseModeSyncing = false;
let appstleInteractionReconcileTimeout = null;
      let latestAppstleVolumeParameters = null;
      let lastKnownAppstleVolumeParameters = null;

      const appstleTierCardSelectorForAwc = [
        '.ab-volume-discount-item-container',
        '.ab-volume-discount-item-container-v2',
        '.ab-volume-discount-item-container-v3'
      ].join(', ');

      const getAppstleTierCardForAwc = (element) => {
        if (!element) return null;
        if (element.matches(appstleTierCardSelectorForAwc)) return element;
        return element.closest(appstleTierCardSelectorForAwc) || element;
      };

      const getAppstleWidgetReferenceForElement = (element) => {
        const widget = element && element.closest('[data-appstle-bundles-widget-unique-ref]');
        return widget
          ? String(widget.getAttribute('data-appstle-bundles-widget-unique-ref') || '')
          : '';
      };

      const getSelectedAppstleTier = (widgetUniqueRef = '') => {
        const selectedTiers = Array.from(new Set(
          Array.from(root.querySelectorAll(appstleSelectedTierSelector))
            .map(getAppstleTierCardForAwc)
            .filter(Boolean)
        ));
        if (!widgetUniqueRef) return selectedTiers[0] || null;

        return selectedTiers.find((tier) => {
          return getAppstleWidgetReferenceForElement(tier) === String(widgetUniqueRef);
        }) || null;
      };

      const getSelectedAppstleVariantIds = (widgetUniqueRef = '') => {
        const selectedTier = getSelectedAppstleTier(widgetUniqueRef);
        if (!selectedTier) return [];

        const rows = Array.from(selectedTier.querySelectorAll('.ab-volume-variant-selector-item'));
        if (!rows.length) return [];

        const selectedVariantIds = rows.map((row) => {
          const validVariantIds = Array.from(
            row.querySelectorAll('select.ab-volume-variant-selector-item-dropdown')
          )
            .map((select) => String(select.value || '').trim())
            .filter((variantId) => variantsById.has(variantId));

          return validVariantIds.length === 1 ? validVariantIds[0] : null;
        });

        return selectedVariantIds.every(Boolean) ? selectedVariantIds : [];
      };

      const appstleSubscriptionCheckboxSelectorForAwc = [
        '.ab-volume-subscription-section[role="checkbox"]'
      ].join(', ');
      const appstleSubscriptionRadioSelectorForAwc = [
        '.ab-volume-subscription-section-v2[role="radio"]',
        '.ab-volume-subscription-section-v3[role="radio"]'
      ].join(', ');
      const appstleOneTimeRadioSelectorForAwc = [
        '.ab-volume-onetime-section-v2[role="radio"]',
        '.ab-volume-onetime-section-v3[role="radio"]'
      ].join(', ');
      const appstleFlavorSelectSelectorForAwc = [
        'select.ab-volume-variant-selector-item-dropdown',
        '.ab-volume-variant-selector-item select',
        'select[class*="volume-variant-selector"][class*="dropdown"]'
      ].join(', ');
      const appstleDeliverySelectSelectorForAwc = [
        'select.ab-volume-subscription-dropdown',
        '.ab-volume-subscription-section select:not(.ab-volume-variant-selector-item-dropdown)',
        '.ab-volume-subscription-section-v2 select:not(.ab-volume-variant-selector-item-dropdown)',
        '.ab-volume-subscription-section-v3 select:not(.ab-volume-variant-selector-item-dropdown)'
      ].join(', ');

      const getAppstleWidgetForAwc = () => {
        const volumeRoot = root.querySelector(appstleVolumeDiscountSelector);
        if (!volumeRoot) return null;

        if (volumeRoot.matches('[data-appstle-bundles-widget-unique-ref]')) {
          return volumeRoot;
        }

        return volumeRoot.querySelector('[data-appstle-bundles-widget-unique-ref]')
          || volumeRoot;
      };

      const getAppstleTierControlsForAwc = (widget) => {
        if (!widget) return [];
        return Array.from(new Set(
          Array.from(widget.querySelectorAll(appstleTierControlSelector))
            .map(getAppstleTierCardForAwc)
            .filter(Boolean)
        ));
      };

      const getAppstleTierNumberForAwc = (control, fallbackIndex = -1) => {
        control = getAppstleTierCardForAwc(control);
        if (!control) return null;

        const classMatch = String(control.className || '').match(
          /(?:^|\s)ab-volume-discount-item-(\d+)(?:\s|$)/
        );
        if (classMatch) return Number.parseInt(classMatch[1], 10);

        const tierAttributeNames = ['data-yv-base-tier', 'data-tier', 'data-tier-number', 'data-tier-index'];
        for (const attributeName of tierAttributeNames) {
          const rawValue = control.getAttribute(attributeName);
          const parsedValue = Number.parseInt(rawValue, 10);
          if (Number.isFinite(parsedValue) && parsedValue >= 1) return parsedValue;
        }

        const titleText = (control.textContent || '').trim();
        const titleMatch = titleText.match(/^(\d+)\s*(?:sets?|bags?|pouch(?:es)?|packs?|items?|units?)\b/i);
        if (titleMatch) return Number.parseInt(titleMatch[1], 10);

        return fallbackIndex >= 0 ? fallbackIndex + 1 : null;
      };

      const getAppstleTierControlForAwc = (widget, tierNumber) => {
        const controls = getAppstleTierControlsForAwc(widget);
        return controls.find((control, index) => {
          return getAppstleTierNumberForAwc(control, index) === tierNumber;
        }) || controls[tierNumber - 1] || null;
      };

      const isAppstleControlSelectedForAwc = (control) => {
        if (!control) return false;
        if (control.getAttribute('aria-checked') === 'true') return true;
        const nestedTierRadio = control.matches(appstleTierCardSelectorForAwc)
          ? control.querySelector('.ab-volume-discount-item-details-wrapper[role="radio"]')
          : null;
        if (nestedTierRadio && nestedTierRadio.getAttribute('aria-checked') === 'true') return true;
        if (control.matches('input[type="checkbox"], input[type="radio"]')) {
          return Boolean(control.checked);
        }
        return /(?:^|\s)(?:is-selected|selected|ab-volume-discount-item-selected)(?:\s|$)/
          .test(String(control.className || ''));
      };

      const clickAppstleControlForAwc = (control) => {
        const clickTarget = control && control.matches(appstleTierCardSelectorForAwc)
          ? (control.querySelector('.ab-volume-discount-item-details-wrapper[role="radio"]') || control)
          : control;
        if (
          !clickTarget
          || clickTarget.getAttribute('aria-disabled') === 'true'
          || clickTarget.disabled
        ) return false;

        clickTarget.click();
        return true;
      };

      const setAppstleSelectValueForAwc = (select, option) => {
        if (!select || !option || option.disabled) return false;
        const nextValue = String(option.value);
        if (String(select.value) === nextValue) return true;

        const valueDescriptor = window.HTMLSelectElement
          && Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value');
        if (valueDescriptor && typeof valueDescriptor.set === 'function') {
          valueDescriptor.set.call(select, nextValue);
        } else {
          select.value = nextValue;
        }

        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return String(select.value) === nextValue;
      };

      const getAppstleFlavorSelectsForAwc = (selectedTier) => {
        selectedTier = getAppstleTierCardForAwc(selectedTier);
        if (!selectedTier) return [];
        return Array.from(new Set(
          selectedTier.querySelectorAll(appstleFlavorSelectSelectorForAwc)
        )).filter((select) => !select.matches(appstleDeliverySelectSelectorForAwc));
      };

      const appstleFlavorSelectionsByTier = new Map();
      let lastAppstleFlavorSelections = [];
      let pendingAppstleFlavorTier = '';
      let isRestoringAppstleFlavorSelections = false;
      let lastSelectedAppstleTierForAwc = Number.parseInt(
        root.dataset.appstleDefaultTier,
        10
      ) || 1;
      let appstleTierRecoveryTimerForAwc = null;
      let appstleTierRecoveryAttemptsForAwc = 0;

      const getAppstleFlavorTierKey = (tierControl) => {
        tierControl = getAppstleTierCardForAwc(tierControl);
        const widget = getAppstleWidgetForAwc();
        const controls = getAppstleTierControlsForAwc(widget);
        const index = controls.indexOf(tierControl);
        const tier = getAppstleTierNumberForAwc(tierControl, index);
        return Number.isFinite(tier) ? String(tier) : '';
      };

      const rememberAppstleFlavorSelectionsForAwc = (tierControl = getSelectedAppstleTier()) => {
        if (!tierControl || isRestoringAppstleFlavorSelections) return [];
        const tierKey = getAppstleFlavorTierKey(tierControl);
        const selections = getAppstleFlavorSelectsForAwc(tierControl)
          .map((select) => String(select.value || ''))
          .filter((variantId) => variantsById.has(variantId));
        if (!tierKey || !selections.length) return [];
        appstleFlavorSelectionsByTier.set(tierKey, selections.slice());
        lastAppstleFlavorSelections = selections.slice();
        return selections;
      };

      const beginAppstleFlavorTierSwitch = (event) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        const tierControl = getAppstleTierCardForAwc(
          target.closest(appstleTierControlSelector)
        );
        if (!tierControl) return;
        rememberAppstleFlavorSelectionsForAwc();
        pendingAppstleFlavorTier = getAppstleFlavorTierKey(tierControl);
      };

      const preventSelectedAppstleTierRetoggleForAwc = (event) => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        const tierControl = getAppstleTierCardForAwc(
          target.closest(appstleTierControlSelector)
        );
        if (!tierControl || !isAppstleControlSelectedForAwc(tierControl)) return;

        const isEditableControl = Boolean(target.closest(
          'select, option, input, button, a, label, textarea, [contenteditable="true"]'
        ));
        const isTierActivationKey = event.type === 'keydown'
          && (event.key === 'Enter' || event.key === ' ');
        if (isEditableControl && !isTierActivationKey) return;
        if (event.type === 'keydown' && !isTierActivationKey) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      };

      root.addEventListener('pointerdown', beginAppstleFlavorTierSwitch, true);
      root.addEventListener('click', beginAppstleFlavorTierSwitch, true);
      root.addEventListener('pointerdown', preventSelectedAppstleTierRetoggleForAwc, true);
      root.addEventListener('click', preventSelectedAppstleTierRetoggleForAwc, true);
      root.addEventListener('keydown', preventSelectedAppstleTierRetoggleForAwc, true);
      root.addEventListener('change', (event) => {
        if (isRestoringAppstleFlavorSelections) return;
        const target = event.target;
        if (!target || typeof target.matches !== 'function') return;
        if (!target.matches(appstleFlavorSelectSelectorForAwc)) return;
        window.setTimeout(() => rememberAppstleFlavorSelectionsForAwc(), 0);
      }, true);

      const restoreAppstleFlavorSelectionsForAwc = (summary) => {
        const widget = getAppstleWidgetForAwc();
        const tierNumber = Number.parseInt(summary && summary.selectedTier, 10);
        if (!widget || !Number.isFinite(tierNumber)) return false;

        const tierKey = String(tierNumber);
        let tierControl = getAppstleTierControlForAwc(widget, tierNumber);
        let selects = getAppstleFlavorSelectsForAwc(tierControl);
        if (!selects.length) return false;

        const storedSelections = appstleFlavorSelectionsByTier.get(tierKey) || [];
        const isTierSwitch = pendingAppstleFlavorTier === tierKey;
        const carriedSelections = isTierSwitch ? lastAppstleFlavorSelections : [];
        const fallbackVariantId = carriedSelections[carriedSelections.length - 1]
          || storedSelections[storedSelections.length - 1]
          || '';
        const desiredSelections = selects.map((select, index) => {
          return carriedSelections[index] || storedSelections[index] || fallbackVariantId;
        });
        if (!desiredSelections.some(Boolean)) return false;

        appstleFlavorSelectionsByTier.set(tierKey, desiredSelections.slice());
        let didChange = false;
        let isComplete = true;
        isRestoringAppstleFlavorSelections = true;
        try {
          desiredSelections.forEach((variantId, index) => {
            tierControl = getAppstleTierControlForAwc(getAppstleWidgetForAwc(), tierNumber);
            selects = getAppstleFlavorSelectsForAwc(tierControl);
            const select = selects[index];
            const variant = variantsById.get(String(variantId));
            const option = findAppstleVariantOptionForAwc(select, variant);
            if (!select || !option) {
              isComplete = false;
              return;
            }
            if (String(select.value) !== String(option.value)) {
              didChange = setAppstleSelectValueForAwc(select, option) || didChange;
            }
          });
        } finally {
          isRestoringAppstleFlavorSelections = false;
        }

        if (isComplete) {
          pendingAppstleFlavorTier = '';
          lastAppstleFlavorSelections = desiredSelections.slice();
        }
        return didChange;
      };

      const findAppstleVariantOptionForAwc = (select, variant) => {
        if (!select || !variant) return null;
        const variantId = String(variant.id);
        const variantTitle = normalize(variant.title);
        const options = Array.from(select.options).filter((option) => !option.disabled);

        return options.find((option) => String(option.value) === variantId)
          || options.find((option) => normalize(option.textContent) === variantTitle)
          || options.find((option) => normalize(option.textContent).includes(variantTitle))
          || null;
      };

      const getCurrentVariantForAppstleAwc = () => {
        const selectedVariantId = variantSelect ? String(variantSelect.value || '') : '';
        return variantsById.get(selectedVariantId)
          || variants.find((variant) => variant.available)
          || variants[0]
          || null;
      };

      const getAppstleSubscriptionControlsForAwc = (widget) => {
        if (!widget) return {
          checkbox: null,
          subscriptionRadio: null,
          oneTimeRadio: null
        };

        return {
          checkbox: widget.querySelector(appstleSubscriptionCheckboxSelectorForAwc),
          subscriptionRadio: widget.querySelector(appstleSubscriptionRadioSelectorForAwc),
          oneTimeRadio: widget.querySelector(appstleOneTimeRadioSelectorForAwc)
        };
      };

      const getAppstleSubscriptionSelectedForAwc = (widget) => {
        const controls = getAppstleSubscriptionControlsForAwc(widget);
        return isAppstleControlSelectedForAwc(controls.checkbox)
          || isAppstleControlSelectedForAwc(controls.subscriptionRadio);
      };

      const getAppstleDeliverySelectForAwc = (widget) => {
        if (!widget) return null;
        const selectedSubscription = widget.querySelector(appstleSelectedSubscriptionSelector);
        return (selectedSubscription && selectedSubscription.querySelector('select'))
          || widget.querySelector(appstleDeliverySelectSelectorForAwc)
          || null;
      };

      const findAppstleDeliveryOptionForAwc = (select, weekCount) => {
        if (!select || !Number.isFinite(weekCount) || weekCount < 1) return null;
        const weekPattern = new RegExp(`(?:^|\\D)${weekCount}\\s*(?:[-_\\s]*)weeks?\\b`, 'i');

        return Array.from(select.options).find((option) => {
          if (option.disabled) return false;
          const optionText = `${option.textContent || ''} ${option.value || ''}`;
          const intervalCount = Number.parseInt(
            option.dataset.intervalCount || option.dataset.weeks,
            10
          );
          return intervalCount === weekCount
            || String(option.value) === String(weekCount)
            || weekPattern.test(optionText);
        }) || null;
      };

      const getAppstleDeliveryWeeksForAwc = (select) => {
        if (!select) return null;
        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return null;
        const intervalCount = Number.parseInt(
          selectedOption.dataset.intervalCount || selectedOption.dataset.weeks,
          10
        );
        if (Number.isFinite(intervalCount) && intervalCount > 0) return intervalCount;
        const labelMatch = `${selectedOption.textContent || ''} ${selectedOption.value || ''}`
          .match(/(?:^|\D)(\d+)\s*(?:[-_\s]*)weeks?\b/i);
        return labelMatch ? Number.parseInt(labelMatch[1], 10) : null;
      };

      let preferredAppstleDeliveryWeeksForAwc = Number.parseInt(
        root.dataset.appstleDeliveryWeeks,
        10
      ) || 3;
      let isRestoringAppstleDeliveryForAwc = false;

      root.addEventListener('change', (event) => {
        if (!event.isTrusted || isRestoringAppstleDeliveryForAwc) return;
        const target = event.target;
        if (!target || typeof target.matches !== 'function') return;
        if (!target.matches(appstleDeliverySelectSelectorForAwc)) return;
        const selectedWeeks = getAppstleDeliveryWeeksForAwc(target);
        if (Number.isFinite(selectedWeeks) && selectedWeeks > 0) {
          preferredAppstleDeliveryWeeksForAwc = selectedWeeks;
        }
      }, true);

      /**
       * Configure the currently rendered Appstle volume widget.
       *
       * Supported call forms:
       *   configureAppstleWidgetForAwc({ tier, subscribe, deliveryWeeks, initializeFlavors })
       *   configureAppstleWidgetForAwc(tier, subscribe, deliveryWeeks)
       *
       * Returns true only when the requested state is present in the current DOM.
       * A false return after a click normally means Appstle is re-rendering; callers
       * can retry later without toggling controls that are already selected.
       */
      const configureAppstleWidgetForAwc = (
        request = {},
        positionalSubscribe,
        positionalDeliveryWeeks
      ) => {
        const options = typeof request === 'number'
          ? {
            tier: request,
            subscribe: positionalSubscribe,
            deliveryWeeks: positionalDeliveryWeeks
          }
          : (request && typeof request === 'object' ? request : {});
        const tierNumber = Number.parseInt(
          options.tier != null ? options.tier : options.tierIndex,
          10
        );
        if (!Number.isFinite(tierNumber) || tierNumber < 1 || tierNumber > 3) return false;

        let widget = getAppstleWidgetForAwc();
        if (!widget) return false;

        let tierControl = getAppstleTierControlForAwc(widget, tierNumber);
        if (!tierControl) return false;
        if (!isAppstleControlSelectedForAwc(tierControl)) {
          if (!clickAppstleControlForAwc(tierControl)) return false;
          widget = getAppstleWidgetForAwc();
          tierControl = getAppstleTierControlForAwc(widget, tierNumber);
        }

        let isComplete = Boolean(
          tierControl && isAppstleControlSelectedForAwc(tierControl)
        );
        const subscribeWasRequested = typeof options.subscribe === 'boolean';

        if (subscribeWasRequested) {
          let subscriptionControls = getAppstleSubscriptionControlsForAwc(widget);
          let subscriptionIsSelected = getAppstleSubscriptionSelectedForAwc(widget);

          if (options.subscribe && !subscriptionIsSelected) {
            const subscriptionControl = subscriptionControls.checkbox
              || subscriptionControls.subscriptionRadio;
            isComplete = clickAppstleControlForAwc(subscriptionControl) && isComplete;
          } else if (!options.subscribe) {
            if (
              subscriptionControls.oneTimeRadio
              && !isAppstleControlSelectedForAwc(subscriptionControls.oneTimeRadio)
            ) {
              isComplete = clickAppstleControlForAwc(subscriptionControls.oneTimeRadio)
                && isComplete;
            } else if (subscriptionIsSelected && subscriptionControls.checkbox) {
              isComplete = clickAppstleControlForAwc(subscriptionControls.checkbox)
                && isComplete;
            }
          }

          widget = getAppstleWidgetForAwc();
          subscriptionControls = getAppstleSubscriptionControlsForAwc(widget);
          subscriptionIsSelected = getAppstleSubscriptionSelectedForAwc(widget);
          isComplete = subscriptionIsSelected === options.subscribe && isComplete;
          if (!options.subscribe && subscriptionControls.oneTimeRadio) {
            isComplete = isAppstleControlSelectedForAwc(subscriptionControls.oneTimeRadio)
              && isComplete;
          }
        }

        const deliveryWeeks = Number.parseInt(
          options.deliveryWeeks != null ? options.deliveryWeeks : options.intervalWeeks,
          10
        );
        if (Number.isFinite(deliveryWeeks) && deliveryWeeks > 0) {
          const deliverySelect = getAppstleDeliverySelectForAwc(widget);
          const deliveryOption = findAppstleDeliveryOptionForAwc(deliverySelect, deliveryWeeks);
          isComplete = setAppstleSelectValueForAwc(deliverySelect, deliveryOption) && isComplete;
        }

        if (options.initializeFlavors !== false) {
          widget = getAppstleWidgetForAwc();
          tierControl = getAppstleTierControlForAwc(widget, tierNumber);
          const selectedTier = tierControl && isAppstleControlSelectedForAwc(tierControl)
            ? tierControl
            : null;
          let flavorSelects = getAppstleFlavorSelectsForAwc(selectedTier);
          const requiredFlavorSlots = tierNumber;
          if (flavorSelects.length < requiredFlavorSlots) {
            isComplete = false;
          } else {
            const currentVariant = getCurrentVariantForAppstleAwc();
            for (let index = 0; index < requiredFlavorSlots; index += 1) {
              widget = getAppstleWidgetForAwc();
              tierControl = getAppstleTierControlForAwc(widget, tierNumber);
              flavorSelects = getAppstleFlavorSelectsForAwc(tierControl);
              const select = flavorSelects[index];
              const option = findAppstleVariantOptionForAwc(select, currentVariant);
              isComplete = setAppstleSelectValueForAwc(select, option)
                && isComplete;
            }
          }
        }

        return isComplete;
      };

      const restoreAppstleDeliveryIntervalForAwc = (summary) => {
        if (
          !summary
          || !summary.ready
          || !summary.subscriptionSelected
          || isRestoringAppstleDeliveryForAwc
        ) return false;
        const widget = getAppstleWidgetForAwc();
        const select = getAppstleDeliverySelectForAwc(widget);
        const option = findAppstleDeliveryOptionForAwc(
          select,
          preferredAppstleDeliveryWeeksForAwc
        );
        if (!select || !option || String(select.value) === String(option.value)) return true;

        isRestoringAppstleDeliveryForAwc = true;
        try {
          return setAppstleSelectValueForAwc(select, option);
        } finally {
          isRestoringAppstleDeliveryForAwc = false;
        }
      };

      const ensureAppstleTierSelectionForAwc = (summary) => {
        const selectedTier = Number.parseInt(summary && summary.selectedTier, 10);
        if (Number.isFinite(selectedTier) && selectedTier > 0) {
          lastSelectedAppstleTierForAwc = selectedTier;
          appstleTierRecoveryAttemptsForAwc = 0;
          window.clearTimeout(appstleTierRecoveryTimerForAwc);
          appstleTierRecoveryTimerForAwc = null;
          return true;
        }
        if (!summary || !summary.ready || appstleTierRecoveryTimerForAwc) return false;

        const recoverSelection = () => {
          appstleTierRecoveryTimerForAwc = null;
          const currentSummary = readAppstleWidgetSummaryForAwc();
          const currentTier = Number.parseInt(currentSummary && currentSummary.selectedTier, 10);
          if (Number.isFinite(currentTier) && currentTier > 0) {
            lastSelectedAppstleTierForAwc = currentTier;
            appstleTierRecoveryAttemptsForAwc = 0;
            return;
          }

          const desiredTier = Number.parseInt(pendingAppstleFlavorTier, 10)
            || lastSelectedAppstleTierForAwc
            || Number.parseInt(root.dataset.appstleDefaultTier, 10)
            || 1;
          configureAppstleWidgetForAwc({
            tier: desiredTier,
            initializeFlavors: false
          });
          appstleTierRecoveryAttemptsForAwc += 1;
          if (appstleTierRecoveryAttemptsForAwc < 5) {
            appstleTierRecoveryTimerForAwc = window.setTimeout(recoverSelection, 90);
          }
        };

        appstleTierRecoveryTimerForAwc = window.setTimeout(recoverSelection, 0);
        return false;
      };

      const parseAppstleMoneyTokensForAwc = (text) => {
        const source = String(text || '');
        const matches = source.match(
          /(?:[$€£¥]\s*-?\d[\d,]*(?:\.\d{1,2})?|(?:USD|CAD|AUD|EUR|GBP|JPY)\s*-?\d[\d,]*(?:\.\d{1,2})?|-?\d[\d,]*(?:\.\d{1,2})?\s*(?:USD|CAD|AUD|EUR|GBP|JPY))/gi
        ) || [];

        return matches.map((rawValue) => {
          const currencyMatch = rawValue.match(/[$€£¥]|USD|CAD|AUD|EUR|GBP|JPY/i);
          const amount = Number.parseFloat(rawValue.replace(/[^\d.,-]/g, '').replace(/,/g, ''));
          return {
            text: rawValue.trim(),
            currency: currencyMatch ? currencyMatch[0].toUpperCase() : '',
            amount: Number.isFinite(amount) ? amount : null
          };
        });
      };

      const readAppstlePricingTextForAwc = (scope) => {
        if (!scope) return '';
        const pricingNodes = Array.from(scope.querySelectorAll([
          '[class*="discount-price"]',
          '[class*="original-price"]',
          '[class*="full-price"]',
          '[class*="unit-label"]',
          '[class*="price-info"]',
          '[data-price]'
        ].join(', ')));
        const values = pricingNodes
          .map((node) => {
            // Our per-count price is explanatory copy, never a set price.
            const pricingCopy = node.cloneNode(true);
            pricingCopy.querySelectorAll('[data-yv-appstle-per-count], [data-yv-appstle-discount]')
              .forEach((annotation) => annotation.remove());
            return (pricingCopy.textContent || '').trim().replace(/\s+/g, ' ');
          })
          .filter(Boolean);
        return Array.from(new Set(values)).join(' ');
      };

      /**
       * Read Appstle's rendered state without duplicating its pricing rules.
       * Returns null until the volume widget exists.
       */
      const readAppstleWidgetSummaryForAwc = () => {
        const widget = getAppstleWidgetForAwc();
        if (!widget) return null;

        const tierControls = getAppstleTierControlsForAwc(widget);
        const tiers = tierControls.map((control, index) => {
          const text = (control.textContent || '').trim().replace(/\s+/g, ' ');
          const pricingText = readAppstlePricingTextForAwc(control);
          return {
            tier: getAppstleTierNumberForAwc(control, index),
            selected: isAppstleControlSelectedForAwc(control),
            text,
            pricingText,
            prices: parseAppstleMoneyTokensForAwc(pricingText || text)
          };
        });
        const selectedTierEntry = tiers.find((tier) => tier.selected) || null;
        const selectedTierControl = selectedTierEntry
          ? getAppstleTierControlForAwc(widget, selectedTierEntry.tier)
          : null;
        const subscriptionSelected = getAppstleSubscriptionSelectedForAwc(widget);
        const subscriptionControl = widget.querySelector(appstleSelectedSubscriptionSelector)
          || widget.querySelector(appstleSubscriptionCheckboxSelectorForAwc)
          || widget.querySelector(appstleSubscriptionRadioSelectorForAwc);
        const subscriptionText = subscriptionControl
          ? (subscriptionControl.textContent || '').trim().replace(/\s+/g, ' ')
          : '';
        const deliverySelect = getAppstleDeliverySelectForAwc(widget);
        const selectedDeliveryOption = deliverySelect
          ? deliverySelect.options[deliverySelect.selectedIndex]
          : null;
        const deliveryLabel = selectedDeliveryOption
          ? (selectedDeliveryOption.textContent || '').trim().replace(/\s+/g, ' ')
          : '';
        const deliveryWeekMatch = deliveryLabel.match(/(\d+)\s*(?:[-_\s]*)weeks?\b/i);
        const selectedFlavorSelects = getAppstleFlavorSelectsForAwc(selectedTierControl);
        const selectedVariantIds = selectedFlavorSelects.map((select) => String(select.value || ''));
        const selectedFlavorLabels = selectedFlavorSelects.map((select) => {
          const option = select.options[select.selectedIndex];
          return option ? (option.textContent || '').trim().replace(/\s+/g, ' ') : '';
        });
        const selectedText = selectedTierEntry ? selectedTierEntry.text : '';
        const summaryText = [selectedText, subscriptionSelected ? subscriptionText : '']
          .filter(Boolean)
          .join(' ');
        const percentageMatches = summaryText.match(/\d+(?:\.\d+)?\s*%/g) || [];

        return {
          ready: tierControls.length > 0,
          widgetUniqueRef: getAppstleWidgetReferenceForElement(widget)
            || String(widget.getAttribute('data-appstle-bundles-widget-unique-ref') || ''),
          selectedTier: selectedTierEntry ? selectedTierEntry.tier : null,
          selectedSubscription: subscriptionSelected,
          subscriptionSelected,
          subscriptionText,
          deliveryWeeks: deliveryWeekMatch
            ? Number.parseInt(deliveryWeekMatch[1], 10)
            : null,
          deliveryLabel,
          selectedVariantIds,
          selectedFlavorLabels,
          selectedTierText: selectedText,
          summaryText,
          pricingText: selectedTierEntry ? selectedTierEntry.pricingText : '',
          prices: selectedTierEntry ? selectedTierEntry.prices : [],
          savingsPercents: percentageMatches.map((value) => Number.parseFloat(value)),
          tiers
        };
      };

      const isAppstleNodeForAwc = (node) => {
        const element = node && node.nodeType === Node.ELEMENT_NODE
          ? node
          : (node && node.parentElement);
        if (!element || typeof element.matches !== 'function') return false;
        return element.matches(appstleVolumeDiscountSelector)
          || Boolean(element.closest(appstleVolumeDiscountSelector))
          || Boolean(element.querySelector(appstleVolumeDiscountSelector));
      };

      /**
       * Observe this product's Appstle widget. The callback receives
       * (readAppstleWidgetSummaryForAwc(), currentWidget) after initial render
       * and subsequent Appstle DOM/control changes. Returns a disconnect function.
       */
      const observeAppstleWidgetForAwc = (callback) => {
        if (typeof callback !== 'function') return () => {};

        let disconnected = false;
        let callbackQueued = false;
        let callbackTimer = null;
        const notify = () => {
          if (disconnected || callbackQueued) return;
          callbackQueued = true;
          callbackTimer = window.setTimeout(() => {
            callbackTimer = null;
            callbackQueued = false;
            if (disconnected) return;
            callback(readAppstleWidgetSummaryForAwc(), getAppstleWidgetForAwc());
          }, 80);
        };
        const observer = new MutationObserver((records) => {
          if (records.some((record) => {
            if (isAppstleNodeForAwc(record.target)) return true;
            return Array.from(record.addedNodes || []).some(isAppstleNodeForAwc)
              || Array.from(record.removedNodes || []).some(isAppstleNodeForAwc);
          })) notify();
        });
        observer.observe(root, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-checked', 'class', 'disabled', 'selected', 'value']
        });

        const handleControlEvent = (event) => {
          if (isAppstleNodeForAwc(event.target)) notify();
        };
        const handleAppstleEvent = (event) => {
          const detail = event && event.detail;
          const eventProductId = detail && detail.productId != null
            ? String(detail.productId)
            : '';
          if (
            eventProductId
            && root.dataset.productId
            && eventProductId !== String(root.dataset.productId)
          ) return;
          notify();
        };
        root.addEventListener('click', handleControlEvent, true);
        root.addEventListener('change', handleControlEvent, true);
        document.addEventListener('appstleBundlesAppliedVolumeDiscount', handleAppstleEvent);
        document.addEventListener('appstle:bundles-interceptor:ready', handleAppstleEvent);
        notify();

        return () => {
          if (disconnected) return;
          disconnected = true;
          window.clearTimeout(callbackTimer);
          observer.disconnect();
          root.removeEventListener('click', handleControlEvent, true);
          root.removeEventListener('change', handleControlEvent, true);
          document.removeEventListener('appstleBundlesAppliedVolumeDiscount', handleAppstleEvent);
          document.removeEventListener('appstle:bundles-interceptor:ready', handleAppstleEvent);
        };
      };

      const serializeAppstleLineValue = (value) => {
        if (Array.isArray(value)) {
          return `[${value.map(serializeAppstleLineValue).join(',')}]`;
        }
        if (value && typeof value === 'object') {
          return `{${Object.keys(value).sort().map((key) => {
            return `${JSON.stringify(key)}:${serializeAppstleLineValue(value[key])}`;
          }).join(',')}}`;
        }
        return JSON.stringify(value);
      };

      const normalizeAppstleVolumeParameters = (parameters) => {
        if (!parameters || typeof parameters !== 'object') return parameters;

        const customProps = parameters.customProps || {};
        const isVolumeDiscount = customProps._appstle_bundles_type === 'VOLUME_DISCOUNT';
        const isCurrentProduct = !parameters.productId
          || !root.dataset.productId
          || String(parameters.productId) === String(root.dataset.productId);
        if (!isVolumeDiscount || !isCurrentProduct || !parameters.hasMultipleVariants) {
          return parameters;
        }

        let selectedVariants = Array.isArray(parameters.selectedVariants)
          ? parameters.selectedVariants
          : [];

        // Appstle can briefly publish an empty list after a tier is selected.
        // The rendered flavor rows are already current at that point, so use
        // them to keep its quantity-one fallback from winning the submit race.
        if (!selectedVariants.length && parameters.hasMultipleVariants) {
          selectedVariants = getSelectedAppstleVariantIds(parameters.widgetUniqueRef).map((variantId) => ({
            id: variantId,
            quantity: 1
          }));
        }

        if (!selectedVariants.length) return parameters;

        const groupedLines = new Map();
        selectedVariants.forEach((entry) => {
          const sourceLine = entry && typeof entry === 'object' ? entry : { id: entry };
          const variantId = sourceLine.id != null ? sourceLine.id : sourceLine.variantId;
          if (variantId == null || String(variantId).trim() === '') return;

          const quantity = Math.max(1, Number.parseInt(sourceLine.quantity, 10) || 1);
          const sellingPlan = sourceLine.selling_plan != null
            ? sourceLine.selling_plan
            : (parameters.isVolumeDiscountHasOtherProducts ? null : parameters.sellingPlanId);
          const properties = sourceLine.properties && typeof sourceLine.properties === 'object'
            ? sourceLine.properties
            : null;
          const lineKey = [
            String(variantId),
            sellingPlan == null ? '' : String(sellingPlan),
            serializeAppstleLineValue(properties || {})
          ].join('|');
          const existingLine = groupedLines.get(lineKey);

          if (existingLine) {
            existingLine.quantity += quantity;
            return;
          }

          groupedLines.set(lineKey, {
            ...sourceLine,
            id: variantId,
            quantity,
            ...(sellingPlan == null ? {} : { selling_plan: sellingPlan }),
            ...(properties ? { properties } : {})
          });
        });

        const normalizedLines = Array.from(groupedLines.values());
        if (!normalizedLines.length) return parameters;

        const totalQuantity = normalizedLines.reduce((sum, line) => sum + line.quantity, 0);
        const isSingleCurrentVariant = normalizedLines.length === 1
          && String(normalizedLines[0].id) === String(parameters.variantId);

        return {
          ...parameters,
          quantity: isSingleCurrentVariant ? totalQuantity : parameters.quantity,
          selectedVariants: normalizedLines,
          hasMultipleVariants: parameters.hasMultipleVariants
            || (!parameters.isVolumeDiscountHasOtherProducts && totalQuantity > 1)
        };
      };

      const cacheAppstleVolumeParameters = (parameters) => {
        const normalizedParameters = normalizeAppstleVolumeParameters(parameters);
        const customProps = normalizedParameters && normalizedParameters.customProps;
        const isCurrentProduct = normalizedParameters
          && (
            !normalizedParameters.productId
            || !root.dataset.productId
            || String(normalizedParameters.productId) === String(root.dataset.productId)
          );

        if (
          isCurrentProduct
          && customProps
          && customProps._appstle_bundles_type === 'VOLUME_DISCOUNT'
        ) {
          latestAppstleVolumeParameters = normalizedParameters;
          lastKnownAppstleVolumeParameters = normalizedParameters;
        }

        return normalizedParameters;
      };

      const getAppstleReturnContextForAwc = (formDataInput = null) => {
        const parameters = latestAppstleVolumeParameters || lastKnownAppstleVolumeParameters;
        const formData = formDataInput || (productForm ? new FormData(productForm) : null);
        const properties = {};
        const isNativeAppstleProperty = (propertyName) => {
          return /^_+appstle/i.test(String(propertyName || ''));
        };
        const copyNativeProperties = (source) => {
          Object.entries(source && typeof source === 'object' ? source : {}).forEach(([name, value]) => {
            if (isNativeAppstleProperty(name) && value != null && String(value).trim() !== '') {
              properties[name] = String(value);
            }
          });
        };

        copyNativeProperties(parameters && parameters.customProps);
        (Array.isArray(parameters && parameters.selectedVariants)
          ? parameters.selectedVariants
          : []).forEach((line) => copyNativeProperties(line && line.properties));

        if (formData) {
          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            const isFile = typeof File !== 'undefined' && value instanceof File;
            if (
              propertyMatch
              && isNativeAppstleProperty(propertyMatch[1])
              && !isFile
              && String(value).trim() !== ''
            ) {
              properties[propertyMatch[1]] = String(value);
            }
          });
        }

        if (
          String(properties._appstle_bundles_type || '').toUpperCase() !== 'VOLUME_DISCOUNT'
          || !properties['_appstle-bb-id']
        ) return null;

        const widget = getAppstleWidgetForAwc();
        const subscriptionIsSelected = getAppstleSubscriptionSelectedForAwc(widget);
        const shouldSubscribe = subscriptionIsSelected
          || root.dataset.appstlePreselectSubscription === 'true';
        let sellingPlanId = '';

        if (shouldSubscribe) {
          const deliverySelect = getAppstleDeliverySelectForAwc(widget);
          const preferredOption = findAppstleDeliveryOptionForAwc(
            deliverySelect,
            preferredAppstleDeliveryWeeksForAwc
          );
          const selectedLineWithPlan = (Array.isArray(parameters && parameters.selectedVariants)
            ? parameters.selectedVariants
            : []).find((line) => line && line.selling_plan != null);

          sellingPlanId = String(
            (preferredOption && preferredOption.value)
            || (selectedLineWithPlan && selectedLineWithPlan.selling_plan)
            || (parameters && parameters.sellingPlanId)
            || (formData && formData.get('selling_plan'))
            || (deliverySelect && deliverySelect.value)
            || ''
          ).trim();

          // Do not save a one-time fallback when Subscribe & Save is the configured
          // mode. Appstle can publish the bundle properties just before its delivery
          // selector is ready, so the caller will briefly retry instead.
          if (!sellingPlanId) return null;
        }

        const context = {
          properties,
          sellingPlanId
        };

        try {
          window.sessionStorage.setItem(
            `${appstleReturnContextStoragePrefix}${root.dataset.productId}`,
            JSON.stringify(context)
          );
        } catch (error) {
          // Line-item properties remain the source of truth when storage is unavailable.
        }

        return context;
      };

      const waitForAppstleReturnContextForAwc = async (form, timeout = 1800) => {
        const startedAt = Date.now();
        let context = getAppstleReturnContextForAwc(form ? new FormData(form) : null);

        while (!context && Date.now() - startedAt < timeout) {
          await new Promise((resolve) => window.setTimeout(resolve, 60));
          context = getAppstleReturnContextForAwc(form ? new FormData(form) : null);
        }

        return context;
      };

      const appstleNormalizerRegistryKey = '__awcAppstleVolumeParameterNormalizerRegistry';
      const installAppstleVolumeParameterNormalizer = () => {
        const registry = window[appstleNormalizerRegistryKey] || {
          normalizers: new Set(),
          wrappedInitializer: null
        };
        window[appstleNormalizerRegistryKey] = registry;
        cacheAppstleVolumeParameters.awcRoot = root;
        registry.normalizers.add(cacheAppstleVolumeParameters);

        const currentInitializer = window.initAppstleBundlesInterceptor;
        if (
          typeof currentInitializer !== 'function'
          || currentInitializer === registry.wrappedInitializer
        ) return;

        const wrappedInitializer = function appstleAwcVolumeInitializer(parameters, ...args) {
          let normalizedParameters = parameters;
          Array.from(registry.normalizers).forEach((normalizer) => {
            if (normalizer.awcRoot && normalizer.awcRoot.isConnected === false) {
              registry.normalizers.delete(normalizer);
              return;
            }
            try {
              normalizedParameters = normalizer(normalizedParameters);
            } catch (error) {
              // Keep Appstle's original parameters if a detached section is mid-cleanup.
            }
          });
          return currentInitializer.call(this, normalizedParameters, ...args);
        };

        registry.wrappedInitializer = wrappedInitializer;
        window.initAppstleBundlesInterceptor = wrappedInitializer;
      };

      const setProductFormFieldValue = (form, name, value) => {
        let fields = Array.from(form.elements).filter((element) => element.name === name);
        if (!fields.length) {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = name;
          form.appendChild(field);
          fields = [field];
        }
        fields.forEach((field) => { field.value = String(value); });
      };

      const syncSingleOrIdenticalAppstleSelectionToForm = (form) => {
        const parameters = latestAppstleVolumeParameters;
        const customProps = parameters && parameters.customProps;
        if (!parameters || !customProps || !customProps['_appstle-bb-id']) return false;

        const selectedTier = getSelectedAppstleTier(parameters.widgetUniqueRef);
        if (!selectedTier) return false;
        const selectedWidgetReference = getAppstleWidgetReferenceForElement(selectedTier);
        if (
          parameters.widgetUniqueRef
          && selectedWidgetReference !== String(parameters.widgetUniqueRef)
        ) return false;

        const selectedVariantIds = getSelectedAppstleVariantIds(parameters.widgetUniqueRef);
        if (!selectedVariantIds.length) return false;

        // Quantity one and same-flavor tiers can use Shopify's native form submit.
        // Sync them here so a preselected subscription never depends on Appstle's
        // asynchronous interceptor state being current at the moment of submit.
        const selectedVariantId = selectedVariantIds[0];
        const isIdenticalSelection = selectedVariantIds.every((variantId) => {
          return variantId === selectedVariantId;
        });
        const formVariantId = form.querySelector('[name="id"]');
        if (
          !isIdenticalSelection
          || !formVariantId
          || String(formVariantId.value) !== selectedVariantId
        ) return false;

        const cachedLine = Array.isArray(parameters.selectedVariants)
          ? parameters.selectedVariants.find((line) => {
            if (!line || typeof line !== 'object') return false;
            const lineVariantId = line.id != null ? line.id : line.variantId;
            return String(lineVariantId) === selectedVariantId;
          })
          : null;
        const normalizedParameters = normalizeAppstleVolumeParameters({
          ...parameters,
          variantId: selectedVariantId,
          selectedVariants: selectedVariantIds.map((variantId) => ({
            ...(cachedLine || {}),
            id: variantId,
            quantity: 1
          }))
        });
        const normalizedLine = normalizedParameters.selectedVariants[0];
        if (!normalizedLine || normalizedLine.quantity < 1) return false;

        setProductFormFieldValue(form, 'id', normalizedLine.id);
        setProductFormFieldValue(form, 'quantity', normalizedLine.quantity);

        const selectedWidget = selectedTier.closest('[data-appstle-bundles-widget-unique-ref]');
        const selectedSubscription = selectedWidget
          ? selectedWidget.querySelector(appstleSelectedSubscriptionSelector)
          : null;
        const planSelect = selectedSubscription
          ? selectedSubscription.querySelector('select')
          : null;
        const sellingPlan = normalizedLine.selling_plan
          || normalizedParameters.sellingPlanId
          || (planSelect && planSelect.value);
        if (selectedSubscription && sellingPlan) {
          setProductFormFieldValue(form, 'selling_plan', sellingPlan);
        } else if (!selectedSubscription) {
          Array.from(form.elements)
            .filter((element) => element.name === 'selling_plan')
            .forEach((field) => { field.value = ''; });
        }

        const lineProperties = normalizedLine.properties && typeof normalizedLine.properties === 'object'
          ? normalizedLine.properties
          : {};
        Object.entries({ ...customProps, ...lineProperties }).forEach(([key, value]) => {
          if (value != null) setProductFormFieldValue(form, `properties[${key}]`, value);
        });

        return true;
      };

      document.addEventListener('appstle:bundles-interceptor:ready', installAppstleVolumeParameterNormalizer);
      installAppstleVolumeParameterNormalizer();

      const syncAppstleTierQuantityCopy = (tierControl, quantity) => {
        if (!tierControl || !Number.isFinite(quantity) || quantity < 1) return;
        const title = tierControl.querySelector([
          '.ab-volume-discount-item-title-label',
          '.ab-volume-discount-item-title-label-v2',
          '.ab-volume-discount-item-title-label-v3'
        ].join(', '));
        if (!title) return;

        const textNodes = [];
        const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
        let textNode = walker.nextNode();
        while (textNode) {
          textNodes.push(textNode);
          textNode = walker.nextNode();
        }

        // Keep the words from the title set in Appstle ("3 Pouches (60 sticks)",
        // "3 Sets (60 stick packs)") and change only the numbers.
        const unitPlurals = { bag: 'bags', set: 'sets', pouch: 'pouches' };
        textNodes.forEach((node) => {
          const nextText = String(node.nodeValue || '')
            .replace(/\b\d+(\s+)(bag|set|pouch)(?:es|s)?\b/i, (match, space, unit) => {
              if (quantity === 1) return `${quantity}${space}${unit}`;
              const suffix = unitPlurals[unit.toLowerCase()].slice(unit.length);
              return `${quantity}${space}${unit}${unit === unit.toUpperCase() ? suffix.toUpperCase() : suffix}`;
            })
            .replace(
              /\(\s*\d+(\s+)(stick\s+packs?|sticks?)\s*\)/i,
              (match, space, unit) => `(${quantity * yvConfig.stickPacksPerBag}${space}${unit})`
            );
          if (nextText !== node.nodeValue) node.nodeValue = nextText;
        });
      };

      const syncAppstleTierListPrice = (tierControl) => {
        if (!tierControl) return;
        const flavorVariants = getAppstleFlavorSelectsForAwc(tierControl)
          .map((select) => variantsById.get(String(select.value)))
          .filter(Boolean);
        const fallbackVariant = getSelectedVariant() || variants[0] || null;
        const pricedVariants = flavorVariants.length ? flavorVariants : [fallbackVariant].filter(Boolean);
        const listPrices = pricedVariants
          .map((variant) => Number.parseInt(variant.priceCents, 10))
          .filter(Number.isFinite);
        if (!listPrices.length) return;

        const unitListPrice = Math.round(
          listPrices.reduce((total, priceCents) => total + priceCents, 0) / listPrices.length
        );
        const priceInfo = tierControl.querySelector([
          '.ab-volume-discount-item-price-info',
          '.ab-volume-discount-item-price-info-v2',
          '.ab-volume-discount-item-price-info-v3'
        ].join(', '));
        if (!priceInfo) return;

        let fullPrice = priceInfo.querySelector([
          '.ab-volume-discount-item-original-price',
          '.ab-volume-discount-item-original-price-v2',
          '.ab-volume-discount-item-original-price-v3'
        ].join(', '));
        if (!fullPrice) {
          const suffix = priceInfo.classList.contains('ab-volume-discount-item-price-info-v2')
            ? '-v2'
            : (priceInfo.classList.contains('ab-volume-discount-item-price-info-v3') ? '-v3' : '');
          fullPrice = document.createElement('div');
          fullPrice.className = `ab-volume-discount-item-original-price${suffix}`;
          const value = document.createElement('span');
          value.className = `volume-original-price${suffix}`;
          fullPrice.appendChild(value);
          priceInfo.appendChild(fullPrice);
        }

        const displayedPrice = priceInfo.querySelector([
          '.volume-discount-price',
          '.volume-discount-price-v2',
          '.volume-discount-price-v3',
          '.ab-volume-discount-item-discount-price',
          '.ab-volume-discount-item-discount-price-v2',
          '.ab-volume-discount-item-discount-price-v3'
        ].join(', '));
        const priceToken = parseAppstleMoneyTokensForAwc(displayedPrice && displayedPrice.textContent)[0];
        const displayedUnitCents = priceToken && Number.isFinite(priceToken.amount)
          ? Math.round(priceToken.amount * 100)
          : null;
        // Compare the rendered price so subscription and volume discounts both count.
        fullPrice.hidden = displayedUnitCents === null || displayedUnitCents >= unitListPrice;
        const value = fullPrice.querySelector([
          '.volume-original-price',
          '.volume-original-price-v2',
          '.volume-original-price-v3'
        ].join(', ')) || fullPrice;
        const formattedListPrice = formatCents(unitListPrice);
        if (value.textContent !== formattedListPrice) value.textContent = formattedListPrice;

        const priceLine = priceInfo.querySelector([
          '.ab-volume-discount-item-discount-price',
          '.ab-volume-discount-item-discount-price-v2',
          '.ab-volume-discount-item-discount-price-v3'
        ].join(', '));
        const isDiscounted = displayedUnitCents !== null && displayedUnitCents < unitListPrice;
        if (priceLine) {
          let discount = priceLine.querySelector('[data-yv-appstle-discount]');
          if (!discount) {
            discount = document.createElement('span');
            discount.className = 'yv-appstle-discount';
            discount.setAttribute('data-yv-appstle-discount', '');
            priceLine.prepend(discount);
          }
          const discountText = isDiscounted
            ? formatCardDiscountPercent((1 - displayedUnitCents / unitListPrice) * 100)
            : '';
          if (discount.textContent !== discountText) discount.textContent = discountText;
          discount.hidden = !isDiscounted;
        }

        let perCount = priceInfo.querySelector('[data-yv-appstle-per-count]');
        if (!perCount) {
          perCount = document.createElement('div');
          perCount.className = 'yv-appstle-per-count';
          perCount.setAttribute('data-yv-appstle-per-count', '');
          priceInfo.appendChild(perCount);
        }
        const perCountText = displayedUnitCents === null ? ''
          : `(${formatCents(Math.round(displayedUnitCents / yvConfig.stickPacksPerBag))}/count)`;
        if (perCount.textContent !== perCountText) perCount.textContent = perCountText;
        perCount.hidden = !isDiscounted;
      };

      const syncAppstlePresentationForAwc = (summary) => {
        const widget = getAppstleWidgetForAwc();
        if (!widget) return;

        getAppstleTierControlsForAwc(widget).forEach((tierControl, index) => {
          const storedTierQuantity = Number.parseInt(tierControl.dataset.yvBaseTier, 10) || 0;
          const tierQuantity = storedTierQuantity
            || getAppstleTierNumberForAwc(tierControl, index)
            || index + 1;
          if (!storedTierQuantity) tierControl.dataset.yvBaseTier = String(tierQuantity);
          const flavorQuantity = getAppstleFlavorSelectsForAwc(tierControl).length;
          const isSelectedTier = isAppstleControlSelectedForAwc(tierControl);
          tierControl.dataset.yvSelectedTier = String(isSelectedTier);
          const displayedQuantity = isSelectedTier
            ? Math.max(tierQuantity, flavorQuantity, Number.parseInt(summary && summary.selectedTier, 10) || 0)
            : tierQuantity;
          syncAppstleTierQuantityCopy(tierControl, displayedQuantity);
          syncAppstleTierListPrice(tierControl);
        });
      };

const clearAppstleBundleContext = () => {
latestAppstleVolumeParameters = null;
if (typeof window.disableAppstleBundlesInterceptor !== 'function') return;

const widgetReferences = new Set(
Array.from(root.querySelectorAll(appstleVolumeWidgetReferenceSelector))
  .map((element) => element.getAttribute('data-appstle-bundles-widget-unique-ref'))
  .filter(Boolean)
);

widgetReferences.forEach((widgetUniqueRef) => {
try {
  window.disableAppstleBundlesInterceptor({ widgetUniqueRef });
} catch (error) {
}
});

variants.forEach((variant) => {
try {
  window.disableAppstleBundlesInterceptor({
    variantId: String(variant.id)
  });
} catch (error) {
}
});
};

const updateSelectedDescription = (variant) => {
const description = variant && variant.description != null ? String(variant.description) : '';
const mobileDescription = variant && variant.mobileDescription != null
? String(variant.mobileDescription)
: description;
const hasDescription = description.trim().length > 0;

if (!selectedDescription) return;
if (selectedDescriptionDesktop) selectedDescriptionDesktop.textContent = description;
if (selectedDescriptionMobile) selectedDescriptionMobile.textContent = mobileDescription;
selectedDescription.hidden = !hasDescription;
};

const getSelectedBundleOption = () => {
const checkedRadio = bundleRadios.find((radio) => radio.checked);
return checkedRadio ? checkedRadio.closest('[data-yv-bundle-option]') : null;
};

const getBundleOptionQuantity = (bundleOption) => {
const quantity = Number.parseInt(bundleOption && bundleOption.dataset.quantity, 10);
return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
};

const getBundleFlavorSelects = (bundleOption) => {
return bundleOption
? Array.from(bundleOption.querySelectorAll('[data-yv-bundle-flavor-select]'))
: [];
};

const getBundleOptionVariants = (bundleOption) => {
return getBundleFlavorSelects(bundleOption)
.map((select) => variantsById.get(String(select.value)))
.filter(Boolean);
};

const getCurrentQuantity = () => {
const bundleOption = getSelectedBundleOption();
if (bundleSelector && bundleOption) return getBundleOptionQuantity(bundleOption);

const quantity = Number.parseInt(qtyInput && qtyInput.value, 10);
return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
};

const getSelectedBundleLines = () => {
const bundleOption = getSelectedBundleOption();
if (bundleSelector && !bundleOption) return [];

if (!bundleSelector) {
const variant = variantsById.get(String(variantSelect && variantSelect.value));
return variant ? [{ id: variant.id, quantity: getCurrentQuantity(), variant }] : [];
}

const groupedLines = new Map();
getBundleOptionVariants(bundleOption).forEach((variant) => {
const key = String(variant.id);
const existingLine = groupedLines.get(key);

if (existingLine) {
  existingLine.quantity += 1;
} else {
  groupedLines.set(key, {
    id: variant.id,
    quantity: 1,
    variant
  });
}
});

return Array.from(groupedLines.values());
};

const isBundleSelectionAvailable = () => {
if (!bundleSelector) {
const variant = variantsById.get(String(variantSelect && variantSelect.value));
return Boolean(variant && variant.available);
}

const bundleOption = getSelectedBundleOption();
if (!bundleOption) return false;

const variantsForBundle = getBundleOptionVariants(bundleOption);
return variantsForBundle.length === getBundleOptionQuantity(bundleOption)
&& variantsForBundle.every((variant) => variant.available);
};

const updateBundleFlavorColor = (select) => {
if (!select) return;

const selectedOption = select.options[select.selectedIndex];
const flavorLabel = selectedOption ? selectedOption.textContent.trim() : '';
// Option labels are capitalized ("Mango set"), so match the variant's real
// option value; unmatched values use the flavor palette, not the section red.
const variant = variantsById.get(String(select.value));
const optionValue = variant ? (variant.options[optionIndex] || variant.title) : flavorLabel;
const color = colorMap.get(normalize(optionValue)) || getFlavorColor(optionValue, select.value);
const control = select.closest('[data-yv-bundle-flavor-control]');
if (control) control.style.setProperty('--yv-bundle-flavor-color', color);
};

const initializeBundleFlavorDefaults = () => {
const currentVariantId = String(variantSelect && variantSelect.value || yvConfig.currentVariantId);
bundleOptions.forEach((bundleOption) => {
const selects = getBundleFlavorSelects(bundleOption);
selects.forEach((select) => {
  const matchingOption = Array.from(select.options).find((option) => {
    return String(option.value) === currentVariantId && !option.disabled;
  });
  if (matchingOption) select.value = matchingOption.value;
  updateBundleFlavorColor(select);
});
});
};

const formatWithDelimiters = (cents, precision = 2, thousands = ',', decimal = '.') => {
const amount = (Number(cents) / 100).toFixed(precision);
const parts = amount.split('.');
const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
return precision ? `${dollars}${decimal}${parts[1]}` : dollars;
};

const formatMoney = (cents) => {
if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
return window.Shopify.formatMoney(cents, moneyFormat);
}

const formats = {
amount: formatWithDelimiters(cents, 2),
amount_no_decimals: formatWithDelimiters(cents, 0),
amount_with_comma_separator: formatWithDelimiters(cents, 2, '.', ','),
amount_no_decimals_with_comma_separator: formatWithDelimiters(cents, 0, '.', ',')
};

return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, formats[moneyFormatPlaceholder] || formats.amount);
};

const getPlainText = (value) => {
plainTextDecoder.innerHTML = value;
return plainTextDecoder.textContent || value;
};

const formatCents = (cents) => getPlainText(formatMoney(cents));

const getBundleOptionTotalCents = (bundleOption) => {
const quantity = getBundleOptionQuantity(bundleOption);
const variantsForBundle = getBundleOptionVariants(bundleOption);
if (variantsForBundle.length !== quantity) return null;

const prices = variantsForBundle.map((variant) => Number.parseInt(variant.priceCents, 10));
return prices.every(Number.isFinite)
? prices.reduce((total, priceCents) => total + priceCents, 0)
: null;
};

const getVariantTotalCents = (variant) => {
if (bundleSelector) return getBundleOptionTotalCents(getSelectedBundleOption());

const priceCents = Number.parseInt(variant && variant.priceCents, 10);
return Number.isFinite(priceCents) ? priceCents * getCurrentQuantity() : null;
};

const calculateDiscountedCents = (cents) => {
if (!Number.isFinite(cents) || activeDiscountPercent <= 0) return cents;
return Math.max(0, Math.round(cents * (100 - activeDiscountPercent) / 100));
};

const updateBundlePrices = () => {
if (!bundleSelector) return;

const hasDiscount = activeDiscountPercent > 0;
bundleOptions.forEach((bundleOption) => {
const quantity = getBundleOptionQuantity(bundleOption);
const variantsForBundle = getBundleOptionVariants(bundleOption);
if (variantsForBundle.length !== quantity) return;

const originalPrices = variantsForBundle.map((variant) => Number.parseInt(variant.priceCents, 10));
if (!originalPrices.every(Number.isFinite)) return;

const originalPerBagCents = Math.round(
  originalPrices.reduce((total, priceCents) => total + priceCents, 0) / quantity
);
const displayedPerBagCents = hasDiscount
  ? Math.round(
    originalPrices.reduce((total, priceCents) => total + calculateDiscountedCents(priceCents), 0) / quantity
  )
  : originalPerBagCents;
const unitPrice = bundleOption.querySelector('[data-yv-bundle-unit-price]');
const fullPrice = bundleOption.querySelector('[data-yv-bundle-full-price]');
const fullPriceValue = bundleOption.querySelector('[data-yv-bundle-full-price-value]');
const discount = bundleOption.querySelector('[data-yv-bundle-discount]');
const perCount = bundleOption.querySelector('[data-yv-bundle-per-count]');
const isDiscounted = displayedPerBagCents < originalPerBagCents;

if (unitPrice) unitPrice.textContent = formatCents(displayedPerBagCents);
if (fullPrice) fullPrice.hidden = !isDiscounted;
if (fullPriceValue) fullPriceValue.textContent = formatCents(originalPerBagCents);
if (discount) {
  discount.textContent = isDiscounted ? formatCardDiscountPercent(activeDiscountPercent) : '';
  discount.hidden = !isDiscounted;
}
if (perCount) {
  perCount.textContent = `(${formatCents(Math.round(displayedPerBagCents / yvConfig.stickPacksPerBag))}/count)`;
  perCount.hidden = !isDiscounted;
}
});
};

const formatCardDiscountPercent = (percent) => `-${Math.round(percent * 10) / 10}%`;

const formatDiscountPercent = (percent) => {
const rounded = Math.round(percent * 10) / 10;
const label = Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1);
return `Save ${label}%`;
};

const setCouponMessage = (message) => {
if (!couponMessage) return;

couponMessage.textContent = message || '';
couponMessage.hidden = !message;
};

const updateCouponDisplay = () => {
const hasDiscount = activeDiscountPercent > 0;
const displayedCode = activeDiscountCode || 'Coupon';

root.classList.toggle('yv-has-applied-coupon', hasDiscount);

if (couponForm) {
couponForm.hidden = hasDiscount;
}

if (couponApplied) {
couponApplied.hidden = !hasDiscount;
}

if (couponCode) {
couponCode.textContent = displayedCode;
}

if (couponInput && hasDiscount && document.activeElement !== couponInput) {
couponInput.value = activeDiscountCode;
}
};

const updateRenderedPriceSummary = ({
originalCents,
displayedCents,
discountPercent,
fallbackPrice
}) => {
const hasOriginal = Number.isFinite(originalCents);
const hasDisplayed = Number.isFinite(displayedCents);
const resolvedDiscount = Number.isFinite(discountPercent)
? Math.max(0, discountPercent)
: (hasOriginal && hasDisplayed && originalCents > 0
  ? Math.max(0, (1 - displayedCents / originalCents) * 100)
  : 0);

if (currentPrice) {
const nextPriceText = hasDisplayed ? formatCents(displayedCents) : fallbackPrice;
if (root.dataset.purchaseMode === 'coupon') expectedCouponPriceText = nextPriceText;
currentPrice.textContent = nextPriceText;
}

primaryButtonPriceText = hasDisplayed ? formatCents(displayedCents) : '';
setPrimaryButtonLabel(primaryButtonBaseLabel);

if (discountRate) {
discountRate.textContent = resolvedDiscount > 0 ? formatDiscountPercent(resolvedDiscount) : '';
discountRate.hidden = resolvedDiscount <= 0;
}

};

const getAppstleDisplayedUnitCents = (summary) => {
const prices = summary && Array.isArray(summary.prices) ? summary.prices : [];
const amounts = prices
.map((price) => Number.parseFloat(price && price.amount))
.filter((amount) => Number.isFinite(amount) && amount >= 0);
if (!amounts.length) return null;
return Math.round(Math.min(...amounts) * 100);
};

const updatePriceSummary = (variant) => {
updateBundlePrices();
if (!currentPrice || !variant) return;

if (root.dataset.purchaseMode === 'appstle') {
const appstleSummary = typeof readAppstleWidgetSummaryForAwc === 'function'
  ? readAppstleWidgetSummaryForAwc()
  : null;
const selectedAppstleTier = Number.parseInt(appstleSummary && appstleSummary.selectedTier, 10) || 0;
const selectedAppstleFlavorQuantity = Array.isArray(appstleSummary && appstleSummary.selectedVariantIds)
  ? appstleSummary.selectedVariantIds.length
  : 0;
const appstleQuantity = selectedAppstleTier > 0
  ? Math.max(selectedAppstleTier, selectedAppstleFlavorQuantity)
  : (Number.parseInt(root.dataset.appstleDefaultTier, 10) || 1);
const appstleUnitCents = getAppstleDisplayedUnitCents(appstleSummary);
const originalUnitCents = Number.parseInt(variant.priceCents, 10);
const selectedAppstleVariants = Array.isArray(appstleSummary && appstleSummary.selectedVariantIds)
  ? appstleSummary.selectedVariantIds
    .map((variantId) => variantsById.get(String(variantId)))
    .filter(Boolean)
  : [];
const selectedAppstleListPrices = selectedAppstleVariants
  .map((selectedVariant) => Number.parseInt(selectedVariant.priceCents, 10));
const originalCents = selectedAppstleListPrices.length === appstleQuantity
  && selectedAppstleListPrices.every(Number.isFinite)
  ? selectedAppstleListPrices.reduce((total, priceCents) => total + priceCents, 0)
  : (Number.isFinite(originalUnitCents) ? originalUnitCents * appstleQuantity : null);
const displayedCents = Number.isFinite(appstleUnitCents)
  ? appstleUnitCents * appstleQuantity
  : null;

updateRenderedPriceSummary({
  originalCents,
  displayedCents,
  quantity: appstleQuantity,
  discountPercent: null,
  fallbackPrice: variant.price
});
updateCouponDisplay();
return;
}

if (bundleSelector && !getSelectedBundleOption()) {
currentPrice.textContent = '\u2014';
expectedCouponPriceText = '\u2014';
primaryButtonPriceText = '';
setPrimaryButtonLabel(primaryButtonBaseLabel);
if (discountRate) {
  discountRate.textContent = '';
  discountRate.hidden = true;
}
updateCouponDisplay();
return;
}

const originalCents = getVariantTotalCents(variant);
const hasDiscount = activeDiscountPercent > 0;
const discountedCents = Number.isFinite(originalCents)
? (bundleSelector
  ? getBundleOptionVariants(getSelectedBundleOption()).reduce((total, bundleVariant) => {
    return total + calculateDiscountedCents(Number.parseInt(bundleVariant.priceCents, 10));
  }, 0)
  : calculateDiscountedCents(originalCents))
: originalCents;

updateRenderedPriceSummary({
originalCents,
displayedCents: discountedCents,
quantity: getBundleOptionQuantity(getSelectedBundleOption()) || getCurrentQuantity(),
discountPercent: hasDiscount ? activeDiscountPercent : 0,
fallbackPrice: variant.price
});

updateCouponDisplay();
};

const buildBuyNowUrl = (variantId, quantity) => {
const discountQuery = activeDiscountCode
? `?discount=${encodeURIComponent(activeDiscountCode)}`
: '';
return `${cartPermalinkBase}${encodeURIComponent(String(variantId))}:${encodeURIComponent(String(quantity))}${discountQuery}`;
};

const buildBundleBuyNowUrl = (lines) => {
const cartPath = lines
.map((line) => `${encodeURIComponent(String(line.id))}:${encodeURIComponent(String(line.quantity))}`)
.join(',');
const discountQuery = activeDiscountCode
? `?discount=${encodeURIComponent(activeDiscountCode)}`
: '';
return cartPath ? `${cartPermalinkBase}${cartPath}${discountQuery}` : '';
};

const getSelectedVariant = () => {
return variantsById.get(String(variantSelect && variantSelect.value)) || null;
};

const unwrapDiscountApplication = (entry) => {
if (!entry) return null;

return entry.discount_application
|| entry.discountApplication
|| entry;
};

const getDiscountApplications = (cart) => {
if (!cart) return [];

const applications = [
...(Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []),
...(Array.isArray(cart.discount_applications) ? cart.discount_applications : [])
].map(unwrapDiscountApplication).filter(Boolean);

const items = Array.isArray(cart.items) ? cart.items : [];
items.forEach((item) => {
const allocations = Array.isArray(item && item.line_level_discount_allocations)
  ? item.line_level_discount_allocations
  : [];

allocations.forEach((allocation) => {
  const application = unwrapDiscountApplication(allocation);
  if (application) applications.push(application);
});
});

return applications;
};

const isCouponDiscountApplication = (application) => {
if (!application) return false;

const type = normalize(application.type || application.discount_application_type || '');
return type === 'discount_code';
};

const isProductCouponDiscountApplication = (application) => {
if (!isCouponDiscountApplication(application)) return false;

const targetType = normalize(application.target_type || application.targetType || '');
return targetType !== 'shipping_line';
};

const getApplicationPercent = (application) => {
if (!isProductCouponDiscountApplication(application)) return 0;

const valueType = normalize(application.value_type || application.valueType || '');
const value = Number.parseFloat(application.value);
return valueType === 'percentage' && Number.isFinite(value) && value > 0 ? Math.min(100, value) : 0;
};

const getApplicationCode = (application) => {
return (application && (application.code || application.title || application.discount_code) || '').toString().trim();
};

const getCartDiscountState = (cart) => {
const applications = getDiscountApplications(cart);

for (const application of applications) {
const percent = getApplicationPercent(application);
if (percent > 0) {
  return {
    percent,
    code: getApplicationCode(application)
  };
}
}

const hasVisibleDiscount = applications.some(isProductCouponDiscountApplication);
const totalDiscount = Number.parseInt(cart && cart.total_discount, 10);
const originalTotal = Number.parseInt(cart && (cart.original_total_price || cart.items_subtotal_price), 10);

if (hasVisibleDiscount && Number.isFinite(totalDiscount) && totalDiscount > 0 && Number.isFinite(originalTotal) && originalTotal > 0) {
return {
  percent: Math.min(100, Math.round((totalDiscount / originalTotal) * 100)),
  code: ''
};
}

return {
percent: 0,
code: ''
};
};

const updateCartDiscountState = (cart) => {
if (window.YerbaDiscountState) {
window.YerbaDiscountState.syncFromCart(cart, {
  source: 'product-cart-refresh',
  silent: true
});
}

const cartDiscountState = getCartDiscountState(cart);
updateCartPurchaseConflictState(cart);
cartDiscountPercent = cartDiscountState.percent;
cartDiscountCode = cartDiscountState.code;
if (cartDiscountState.percent > 0) setCouponMessage('');
refreshActiveDiscountState();

const variant = getSelectedVariant();
if (variant) updatePurchaseState(variant);
};

const refreshPriceForCouponEligibility = () => {
refreshActiveDiscountState();
const variant = getSelectedVariant();
if (variant) updatePurchaseState(variant);
};

const isCouponKlaviyoFormEvent = (detail) => {
if (!detail) return false;
if (!couponKlaviyoFormIds.length) return true;

const eventFormId = detail.formId || detail.form_id || detail.id || '';
return couponKlaviyoFormIds.includes(String(eventFormId));
};

const isKlaviyoSignupSuccessEvent = (detail) => {
if (!detail) return false;
const eventType = detail.type || detail.action || detail.event || '';
const stepName = String(detail.stepName || detail.step_name || detail.step || '').toLowerCase();
const isSuccessStep = stepName.includes('success') || stepName.includes('coupon') || stepName.includes('thank');
return eventType === 'submit' || eventType === 'stepSubmit' || eventType === 'redirectToUrl' || eventType === 'formRedirect' || eventType === 'formSuccess' || isSuccessStep;
};

const fetchCartJson = async () => {
const response = await fetch(cartJsonUrl, {
credentials: 'same-origin',
headers: {
  Accept: 'application/json'
}
});

if (!response.ok) {
throw new Error('Unable to refresh cart');
}

return response.json();
};

const refreshCartDiscountState = async () => {
try {
updateCartDiscountState(await fetchCartJson());
} catch (error) {
console.warn(error);
}
};

const updateDiscountCodes = async (discountCode) => {
const response = await fetch(cartUpdateUrl, {
method: 'POST',
credentials: 'same-origin',
headers: {
  Accept: 'application/json',
  'Content-Type': 'application/json'
},
body: JSON.stringify({
  discount: discountCode || ''
})
});

if (!response.ok) {
throw new Error('Unable to update coupon code');
}

return response.json();
};

const getCouponProbeLines = () => {
const selectedLines = getSelectedBundleLines();
if (selectedLines.length) return selectedLines;
if (bundleSelector) return [];
if (!couponTestVariantId) return [];

return [{
id: couponTestVariantId,
quantity: getCurrentQuantity()
}];
};

const addCouponProbeItems = async () => {
const probeLines = getCouponProbeLines();
if (!probeLines.length) return null;

activePurchaseSource = 'awc';
clearAppstleBundleContext();
const probeToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
const items = probeLines.map((line) => ({
id: line.id,
quantity: line.quantity,
properties: {
  [couponProbePropertyName]: probeToken,
  [awcPurchaseModePropertyName]: awcPurchaseModeValue
}
}));

const response = await fetch(cartAddUrl, {
method: 'POST',
credentials: 'same-origin',
headers: {
  Accept: 'application/json',
  'Content-Type': 'application/json'
},
body: JSON.stringify({ items })
});

let addedItems = {};
try {
addedItems = await response.json();
} catch (error) {
addedItems = {};
}

if (!response.ok) {
throw new Error(addedItems.description || addedItems.message || 'Unable to add coupon test products');
}

return {
addedItems,
token: probeToken
};
};

const findCouponProbeLineKeys = (cart, addedProbe) => {
const items = Array.isArray(cart && cart.items) ? cart.items : [];
const probeToken = addedProbe && addedProbe.token;
const cartKeys = items.filter((item) => {
const properties = item && item.properties;
return properties
  && properties[couponProbePropertyName]
  && (!probeToken || properties[couponProbePropertyName] === probeToken);
}).map((item) => item.key).filter(Boolean);

if (cartKeys.length) return cartKeys;

const addedItems = addedProbe && addedProbe.addedItems;
const responseItems = Array.isArray(addedItems && addedItems.items) ? addedItems.items : [];
return responseItems.map((item) => item && item.key).filter(Boolean);
};

const removeCartLine = async (lineKey) => {
const response = await fetch(cartChangeUrl, {
method: 'POST',
credentials: 'same-origin',
headers: {
  Accept: 'application/json',
  'Content-Type': 'application/json'
},
body: JSON.stringify({
  id: lineKey,
  quantity: 0
})
});

if (!response.ok) {
throw new Error('Unable to remove coupon test product');
}

return response.json();
};

const removeCouponProbeItems = async (addedProbe, cart) => {
const lineKeys = findCouponProbeLineKeys(cart, addedProbe);
if (!lineKeys.length) return null;

let cleanupCart = cart;
for (const lineKey of lineKeys) {
cleanupCart = await removeCartLine(lineKey);
}

return cleanupCart;
};

const probeDiscountWithTestProduct = async (discountCode) => {
const emptyDiscountState = {
percent: 0,
code: ''
};

if (!shouldEstimateCartDiscount || !getCouponProbeLines().length) {
return emptyDiscountState;
}

let addedProbe = null;
let probedCart = null;
let nextDiscountState = emptyDiscountState;

try {
addedProbe = await addCouponProbeItems();
probedCart = await updateDiscountCodes(discountCode);
nextDiscountState = getCartDiscountState(probedCart);
} catch (error) {
console.warn(error);
}

if (addedProbe || probedCart) {
const cleanupCart = await removeCouponProbeItems(addedProbe, probedCart || await fetchCartJson());
if (cleanupCart) {
  updateCartQuantityDisplay(cleanupCart);
}

try {
  await updateDiscountCodes(discountCode);
} catch (error) {
  console.warn(error);
}
}

if (nextDiscountState.percent > 0) {
return {
  percent: nextDiscountState.percent,
  code: nextDiscountState.code || discountCode
};
}

return emptyDiscountState;
};

const resolveDiscountStateAfterCodeUpdate = async (discountCode, cart) => {
let nextDiscountState = getCartDiscountState(cart);
const itemCount = Number.parseInt(cart && cart.item_count, 10);

if (!nextDiscountState.percent && itemCount === 0 && shouldEstimateCartDiscount) {
const couponProbeLines = getCouponProbeLines();

if (couponProbeLines.length) {
  nextDiscountState = await probeDiscountWithTestProduct(discountCode);
}

if (!nextDiscountState.percent && !couponProbeLines.length && !bundleSelector && estimatedCartDiscountPercent > 0) {
  nextDiscountState = {
    percent: estimatedCartDiscountPercent,
    code: discountCode
  };
}
}

return nextDiscountState;
};

const setCouponBusy = (isBusy) => {
[couponApply, couponRemove].forEach((button) => {
if (!button) return;

button.disabled = isBusy;
button.toggleAttribute('aria-busy', isBusy);
});

if (couponInput) {
couponInput.disabled = isBusy;
}

if (modeToggle) {
modeToggle.disabled = isBusy;
modeToggle.toggleAttribute('aria-busy', isBusy);
}
};

const syncAppliedCouponState = (state, source) => {
cartDiscountPercent = parseDiscountPercent(state && state.percent);
cartDiscountCode = (state && state.code || '').trim();

if (cartDiscountPercent > 0 && window.YerbaDiscountState) {
window.YerbaDiscountState.remember({
  code: cartDiscountCode,
  percent: cartDiscountPercent,
  source
}, {
  source,
  silent: true
});
}

refreshActiveDiscountState();
const variant = getSelectedVariant();
if (variant) updatePurchaseState(variant);
};

const applyDiscountCode = async (discountCode, applyOptions = {}) => {
const cleanDiscountCode = normalizeDiscountCode(discountCode);
if (!cleanDiscountCode) {
return {
  didUpdateCart: false,
  hasDiscount: false
};
}

if (couponRequestPromise) return couponRequestPromise;

const options = Object.assign({
clearInput: false,
setBusy: true,
showError: true,
source: 'product-apply'
}, applyOptions);

couponRequestInFlight = true;
if (options.setBusy) {
setCouponBusy(true);
}
if (options.showError) {
setCouponMessage('');
}

couponRequestPromise = (async () => {
try {
  const cart = await updateDiscountCodes(cleanDiscountCode);
  const nextDiscountState = await resolveDiscountStateAfterCodeUpdate(cleanDiscountCode, cart);

  if (nextDiscountState.percent > 0) {
    setCouponMessage('');
    syncAppliedCouponState({
      percent: nextDiscountState.percent,
      code: nextDiscountState.code || cleanDiscountCode
    }, options.source);

    if (options.clearInput && couponInput) {
      couponInput.value = '';
    }

    updateCartQuantityDisplay(cart);

    return {
      didUpdateCart: true,
      hasDiscount: true
    };
  }

  if (window.YerbaDiscountState) {
    const rememberedDiscountState = getRememberedDiscountState();
    if (rememberedDiscountState.percent > 0 && rememberedDiscountState.code && !discountCodesMatch(rememberedDiscountState.code, cleanDiscountCode)) {
      window.YerbaDiscountState.clear({
        source: `${options.source}-replace`,
        silent: true
      });
    }

    window.YerbaDiscountState.syncFromCart(cart, {
      clearWhenNoDiscount: false,
      source: `${options.source}-no-discount`,
      silent: true
    });
  }

  cartDiscountPercent = 0;
  cartDiscountCode = cleanDiscountCode;
  refreshActiveDiscountState();

  const variant = getSelectedVariant();
  if (variant) updatePriceSummary(variant);
  updateCartQuantityDisplay(cart);

  if (options.showError) {
    setCouponMessage('Coupon could not be applied.');
  }

  return {
    didUpdateCart: true,
    hasDiscount: false
  };
} catch (error) {
  console.warn(error);
  if (options.showError) {
    setCouponMessage('Coupon could not be applied.');
  }

  return {
    didUpdateCart: false,
    hasDiscount: false
  };
}
})();

try {
return await couponRequestPromise;
} finally {
couponRequestInFlight = false;
couponRequestPromise = null;

if (options.setBusy) {
  setCouponBusy(false);
}
}
};

const applyProductCouponCode = async () => {
if (!couponInput) return;
if (root.dataset.purchaseMode !== 'coupon') return;

if (bundleSelector && !getSelectedBundleOption()) {
setCouponMessage('Choose a quantity before applying a coupon.');
return;
}

const enteredDiscountCode = normalizeDiscountCode(couponInput.value);
if (!enteredDiscountCode) {
couponInput.focus();
return;
}

await applyDiscountCode(enteredDiscountCode, {
clearInput: false,
setBusy: true,
showError: true,
source: 'product-apply'
});
};

const applyDiscountCodeFromCookie = async (source = 'product-cookie', options = {}) => {
const cookieDiscountCode = getDiscountCodeFromCookie();
if (!cookieDiscountCode) return false;
if (bundleSelector && (!getSelectedBundleOption() || activePurchaseSource === 'appstle')) return false;

if (!options.force) {
if (activeDiscountPercent > 0 && discountCodesMatch(activeDiscountCode, cookieDiscountCode)) {
  lastCookieDiscountCodeSync = cookieDiscountCode;
  return true;
}

if (lastCookieDiscountCodeSync && discountCodesMatch(lastCookieDiscountCodeSync, cookieDiscountCode)) {
  return false;
}
}

const result = await applyDiscountCode(cookieDiscountCode, {
clearInput: false,
setBusy: false,
showError: false,
source
});

if (result.didUpdateCart) {
lastCookieDiscountCodeSync = cookieDiscountCode;
}

return result.hasDiscount;
};

const scheduleDiscountCodeCookieSync = (source = 'product-cookie') => {
[0, 250, 1000].forEach((delay) => {
window.setTimeout(() => {
  if (root.dataset.purchaseMode !== 'coupon') return;
  applyDiscountCodeFromCookie(source);
}, delay);
});
};

const shouldSyncCookieDiscountBeforeAdd = () => {
if (root.dataset.purchaseMode !== 'coupon') return false;
const cookieDiscountCode = getDiscountCodeFromCookie();
if (!cookieDiscountCode) return false;

if (activeDiscountPercent > 0 && discountCodesMatch(activeDiscountCode, cookieDiscountCode)) {
return false;
}

if (lastCookieDiscountCodeSync && discountCodesMatch(lastCookieDiscountCodeSync, cookieDiscountCode)) {
return false;
}

return true;
};

const removeProductCouponCode = async () => {
if (couponRequestInFlight) return;

couponRequestInFlight = true;
setCouponBusy(true);
setCouponMessage('');

try {
const cart = await updateDiscountCodes('');

if (window.YerbaDiscountState) {
  window.YerbaDiscountState.clear({
    source: 'product-remove',
    silent: true
  });
}

cartDiscountPercent = 0;
cartDiscountCode = '';
activeDiscountPercent = 0;
activeDiscountCode = '';
lastCookieDiscountCodeSync = '';
clearCookie(discountCodeCookieName);
refreshActiveDiscountState();

const variant = getSelectedVariant();
if (variant) updatePurchaseState(variant);
updateCartQuantityDisplay(cart);

if (couponInput) {
  couponInput.value = '';
}
} catch (error) {
console.warn(error);
setCouponMessage('Coupon could not be removed.');
} finally {
couponRequestInFlight = false;
setCouponBusy(false);
}
};

const setAddToCartFeedback = (message, variant, duration = 1600) => {
window.clearTimeout(addToCartFeedbackTimeout);

if (message) setPrimaryButtonLabel(message);

if (bundleStatus && message) {
bundleStatus.textContent = '';
window.requestAnimationFrame(() => {
  bundleStatus.textContent = message;
});
}

addToCartFeedbackTimeout = window.setTimeout(() => {
const currentVariant = variant || getSelectedVariant();
if (currentVariant) updatePurchaseState(currentVariant);
}, duration);
};

const updateCartQuantityDisplay = (cart) => {
const count = Number.parseInt(cart && cart.item_count, 10);
if (!Number.isFinite(count)) return;

const countElements = document.querySelectorAll([
'[data-cart-count-indicator]',
'[data-cart-count]',
'.cart-count-bubble',
'.cart-item-count-bubble',
'.cart-item-count-header--quantity'
].join(','));

countElements.forEach((element) => {
element.textContent = count;
element.classList.toggle('hide', count <= 0);
element.classList.toggle('hidden', count <= 0);
element.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
});

document.querySelectorAll(`.site-header__cart-toggle, .cart-count-enabled, a[href="${cartPageUrl}"]`).forEach((element) => {
element.classList.toggle('cart-count-visible', count > 0);
});
};

const dispatchCartUpdated = (cart, addedItem) => {
const addedItems = addedItem && Array.isArray(addedItem.items) ? addedItem.items : [];
const detail = {
cart,
item: addedItems[0] || addedItem,
items: addedItems.length ? addedItems : [addedItem].filter(Boolean),
source: root
};

['cart:updated', 'theme:cart:updated', 'ajaxCart:updated'].forEach((eventName) => {
document.dispatchEvent(new CustomEvent(eventName, {
  bubbles: true,
  detail
}));
});
};

const addToCartWithAjax = async (form, preserveAppstleQuantity = false) => {
const formData = new FormData(form);

if (!formData.get('id') && variantSelect && variantSelect.value) {
formData.set('id', variantSelect.value);
}

// Appstle may have split a mixed-flavor bundle before resubmitting this form.
// Keep its remaining line quantity instead of replacing it with the AWC one.
if (!preserveAppstleQuantity) formData.set('quantity', String(getCurrentQuantity()));
if (shouldUseCartDrawer) formData.set('sections', 'cart-drawer');

const addResponse = await fetch(cartAddUrl, {
method: 'POST',
credentials: 'same-origin',
headers: {
  Accept: 'application/json'
},
body: formData
});

let addedItem = {};
try {
addedItem = await addResponse.json();
} catch (error) {
addedItem = {};
}

if (!addResponse.ok) {
throw new Error(addedItem.description || addedItem.message || root.dataset.addErrorLabel);
}

// The add has succeeded; a count/discount refresh failure must not prevent
// opening the drawer or encourage the shopper to add the products again.
const cart = await fetchCartJson().catch((error) => {
console.warn(error);
return null;
});

if (cart) updateCartDiscountState(cart);
updateCartQuantityDisplay(cart);
dispatchCartUpdated(cart, addedItem);

return {
addedItem,
cart
};
};

const getSharedBundleLineAttributes = (
form,
formDataInput = null,
appstleReturnContextInput = null
) => {
const formData = formDataInput || new FormData(form);
const appstleReturnContext = appstleReturnContextInput
|| getAppstleReturnContextForAwc(formData);
clearAppstleBundleContext();
const properties = {};
const appstleBundlePropertyNames = new Set([
'_appstle-bb-id',
'__appstle-bb-name',
'_appstle_bundles_type',
'_appstle-free-product',
'_appstle_bundle_combo_id',
'_appstle_tier_upsell_ref',
'_appstle_is_free_gift',
'_appstle_gift_label'
]);

formData.forEach((value, key) => {
const propertyMatch = key.match(/^properties\[(.+)\]$/);
const isFile = typeof File !== 'undefined' && value instanceof File;
if (
  propertyMatch
  && !appstleBundlePropertyNames.has(propertyMatch[1])
  && !isFile
  && String(value).trim() !== ''
) {
  properties[propertyMatch[1]] = String(value);
}
});

properties[awcPurchaseModePropertyName] = awcPurchaseModeValue;
if (appstleReturnContext) {
properties[appstleReturnContextPropertyName] = JSON.stringify(appstleReturnContext);
}

return {
properties,
sellingPlan: null
};
};

const addBundleToCartWithAjax = async (form, selectedLines = null, sharedAttributesInput = null) => {
const lines = Array.isArray(selectedLines) ? selectedLines : getSelectedBundleLines();
const sharedAttributes = sharedAttributesInput || getSharedBundleLineAttributes(form);
const items = lines.map((line) => {
const item = {
  id: line.id,
  quantity: line.quantity
};

if (sharedAttributes.sellingPlan) {
  const sellingPlanId = String(sharedAttributes.sellingPlan);
  const supportsSellingPlan = Array.isArray(line.variant.sellingPlanIds)
    && line.variant.sellingPlanIds.includes(sellingPlanId);
  if (!supportsSellingPlan) {
    throw new Error('The selected purchase plan is not available for every chosen flavor.');
  }
  item.selling_plan = sharedAttributes.sellingPlan;
}
if (Object.keys(sharedAttributes.properties).length) item.properties = sharedAttributes.properties;
return item;
});

const addResponse = await fetch(cartAddUrl, {
method: 'POST',
credentials: 'same-origin',
headers: {
  Accept: 'application/json',
  'Content-Type': 'application/json'
},
body: JSON.stringify({ items, ...(shouldUseCartDrawer ? { sections: 'cart-drawer' } : {}) })
});

let addedItems = {};
try {
addedItems = await addResponse.json();
} catch (error) {
addedItems = {};
}

if (!addResponse.ok) {
throw new Error(addedItems.description || addedItems.message || root.dataset.addErrorLabel);
}

const cart = await fetchCartJson().catch((error) => {
console.warn(error);
return null;
});

if (cart) updateCartDiscountState(cart);
updateCartQuantityDisplay(cart);
dispatchCartUpdated(cart, addedItems);

return {
addedItem: addedItems,
cart
};
};

const handleAddToCartSubmit = async (event) => {
const form = event.currentTarget;
const variant = getSelectedVariant();
const submitter = event.submitter || document.activeElement;
const isAwcAddToCartSubmit = Boolean(
addToCart
&& (
  submitter === addToCart
  || (
    submitter
    && typeof submitter.closest === 'function'
    && submitter.closest('[data-yv-atc]') === addToCart
  )
)
);

if (productCartLimitWouldBeExceeded()) {
event.preventDefault();
event.stopImmediatePropagation();
syncProductCartLimitControls();
const currentVariant = variant || getSelectedVariant();
if (currentVariant) updatePurchaseState(currentVariant);
return;
}

if (couponCodeIsRequiredForAdd()) {
event.preventDefault();
event.stopImmediatePropagation();
const currentVariant = variant || getSelectedVariant();
if (currentVariant) updatePurchaseState(currentVariant);
return;
}

if (bundleSelector) {
const isCouponPurchaseMode = root.dataset.purchaseMode === 'coupon';

if (!isCouponPurchaseMode) {
  activePurchaseSource = 'appstle';
  if (isAwcAddToCartSubmit) {
    syncSingleOrIdenticalAppstleSelectionToForm(form);
  }
  if (shouldUseCartDrawer) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (isBundleSubmitting) return;
    isBundleSubmitting = true;
    if (addToCart) {
      addToCart.disabled = true;
      addToCart.setAttribute('aria-busy', 'true');
    }
    let navigating = false;
    try {
      const result = await addToCartWithAjax(form, true);
      setAddToCartFeedback(root.dataset.addedLabel, variant);
      navigating = await window.YerbaCartDrawer.openAfterAdd(result.addedItem);
    } catch (error) {
      console.warn(error);
      setAddToCartFeedback(root.dataset.addErrorLabel, variant, 2600);
    } finally {
      if (!navigating) {
        isBundleSubmitting = false;
        if (addToCart) addToCart.removeAttribute('aria-busy');
        refreshCurrentPurchaseState();
      }
    }
  }
  return;
}
if (!isAwcAddToCartSubmit) return;

activePurchaseSource = 'awc';

event.preventDefault();
event.stopImmediatePropagation();
if (isBundleSubmitting) return;
if (!isBundleSelectionAvailable()) return;

const selectedLines = getSelectedBundleLines();
isBundleSubmitting = true;
if ('inert' in form) form.inert = true;
form.setAttribute('aria-busy', 'true');
bundleRadios.forEach((radio) => { radio.disabled = true; });
bundleFlavorSelects.forEach((select) => { select.disabled = true; });

if (addToCart) {
  addToCart.disabled = true;
  addToCart.setAttribute('aria-busy', 'true');
}
if (buyNow) buyNow.disabled = true;

let isNavigatingToCart = false;
try {
  if (shouldSyncCookieDiscountBeforeAdd()) {
    await applyDiscountCodeFromCookie('product-before-bundle-add', { force: true });
  }

  const appstleReturnContext = await waitForAppstleReturnContextForAwc(form);
  const sharedAttributes = getSharedBundleLineAttributes(
    form,
    null,
    appstleReturnContext
  );
  const result = await addBundleToCartWithAjax(form, selectedLines, sharedAttributes);
  setAddToCartFeedback(root.dataset.addedLabel, variant);

  if (shouldUseCartDrawer) {
    isNavigatingToCart = await window.YerbaCartDrawer.openAfterAdd(result.addedItem);
  } else {
    isNavigatingToCart = true;
    window.location.href = cartPageUrl;
  }
} catch (error) {
  console.warn(error);
  setAddToCartFeedback(root.dataset.addErrorLabel, variant, 2600);
} finally {
  if (!isNavigatingToCart) {
    isBundleSubmitting = false;
    if ('inert' in form) form.inert = false;
    form.removeAttribute('aria-busy');
    bundleRadios.forEach((radio) => { radio.disabled = false; });
    syncBundleSelectionState(false);
    if (addToCart) {
      addToCart.removeAttribute('aria-busy');
    }
    refreshCurrentPurchaseState();
  }
}

return;
}

if (!shouldUseCartDrawer) {
if (isSubmittingAfterCookieDiscountSync) {
  isSubmittingAfterCookieDiscountSync = false;
  return;
}

if (shouldSyncCookieDiscountBeforeAdd()) {
  event.preventDefault();
  await applyDiscountCodeFromCookie('product-before-submit', { force: true });

  isSubmittingAfterCookieDiscountSync = true;
  if (form && typeof form.requestSubmit === 'function') {
    form.requestSubmit(submitter || undefined);
  } else if (form && typeof form.submit === 'function') {
    form.submit();
  }
}

return;
}

event.preventDefault();
event.stopImmediatePropagation();

if (variant && !variant.available) return;
if (isBundleSubmitting) return;
isBundleSubmitting = true;

if (addToCart) {
addToCart.disabled = true;
addToCart.setAttribute('aria-busy', 'true');
}

try {
if (shouldSyncCookieDiscountBeforeAdd()) {
  await applyDiscountCodeFromCookie('product-before-ajax-add', { force: true });
}

const result = await addToCartWithAjax(form);
setAddToCartFeedback(root.dataset.addedLabel, variant);
await window.YerbaCartDrawer.openAfterAdd(result.addedItem);
} catch (error) {
console.warn(error);
setAddToCartFeedback(root.dataset.addErrorLabel, variant, 2600);
} finally {
isBundleSubmitting = false;
if (addToCart) {
  addToCart.removeAttribute('aria-busy');
  addToCart.disabled = Boolean(variant && !variant.available);
}
}
};

const setSelectedBackground = (optionValue) => {
const color = getColorForOption(optionValue);
root.style.setProperty('--yv-selected-bg', color);
root.style.setProperty('--custom-selected-variant-background', color);
};

const setMainImage = (src, srcset, alt) => {
if (mainVideo) {
mainVideo.pause();
mainVideo.hidden = true;
}
if (mainVideoHost) mainVideoHost.hidden = true;
root.classList.remove('yv-main-media-is-video');
if (!mainImage || !src) return;

mainImage.hidden = false;
if (mainCard) {
mainCard.classList.remove('is-video');
mainCard.setAttribute('role', 'button');
mainCard.setAttribute('tabindex', '0');
mainCard.setAttribute('aria-haspopup', 'dialog');
mainCard.setAttribute('aria-label', 'Open product image gallery');
}
invalidateZoomBounds(mainZoomState);
mainImage.src = src;
if (srcset) {
mainImage.srcset = srcset;
} else {
mainImage.removeAttribute('srcset');
}
if (alt) mainImage.alt = alt;
resetMainZoom();
};

const setMainVideo = (item) => {
const sources = Array.isArray(item && item.videoSources)
? item.videoSources.filter((source) => source && source.src)
: [];
const mediaId = String(item && (item.mediaId || item.id) || '');
const videoTemplate = videoTemplates.find((template) => {
return String(template.dataset.yvVideoTemplate || '') === mediaId;
});

if (!mainVideoHost || (!videoTemplate && !sources.length)) {
setMainImage(item && item.image, item && item.srcset, item && item.alt);
return;
}

if (mainVideo) mainVideo.pause();
mainVideoHost.textContent = '';

if (videoTemplate && videoTemplate.content) {
mainVideoHost.appendChild(videoTemplate.content.cloneNode(true));
mainVideo = mainVideoHost.querySelector('video');
} else {
mainVideo = document.createElement('video');
mainVideo.className = 'yv-main-video';
mainVideo.playsInline = true;
mainVideo.preload = 'metadata';

sources.forEach((sourceData) => {
  const source = document.createElement('source');
  source.src = sourceData.src;
  if (sourceData.type) source.type = sourceData.type;
  mainVideo.appendChild(source);
});

mainVideoHost.appendChild(mainVideo);
}

if (!mainVideo) {
setMainImage(item && item.image, item && item.srcset, item && item.alt);
return;
}

resetMainZoom();
if (mainImage) mainImage.hidden = true;
root.classList.add('yv-main-media-is-video');
mainVideoHost.hidden = false;
mainVideo.hidden = false;
mainVideo.poster = item.image || '';
mainVideo.setAttribute('aria-label', item.alt || 'Product video');
mainVideo.autoplay = videoAutoplay;
mainVideo.defaultMuted = videoAutoplay;
mainVideo.muted = videoAutoplay;
mainVideo.loop = videoLoop;
mainVideo.controls = videoControls;

if (mainCard) {
mainCard.classList.add('is-video');
mainCard.removeAttribute('role');
mainCard.removeAttribute('tabindex');
mainCard.removeAttribute('aria-haspopup');
mainCard.setAttribute('aria-label', item.alt || 'Product video');
}

mainVideo.load();

if (videoAutoplay) {
const playPromise = mainVideo.play();
if (playPromise && typeof playPromise.catch === 'function') {
  playPromise.catch(() => {
    mainVideo.controls = true;
  });
}
}
};

const setMainMedia = (item) => {
if (!item) return;

if (item.mediaType === 'video') {
setMainVideo(item);
} else {
setMainImage(item.image, item.srcset, item.alt);
}
};

const getThumbMediaItem = (thumb) => {
if (!thumb) return null;

const galleryIndex = Number.parseInt(thumb.dataset.galleryIndex, 10);
if (Number.isFinite(galleryIndex) && activeGalleryItems[galleryIndex]) {
return activeGalleryItems[galleryIndex];
}

let videoSources = [];
try {
videoSources = JSON.parse(thumb.dataset.videoSources || '[]');
} catch (error) {
videoSources = [];
}

return {
id: thumb.dataset.mediaId || thumb.dataset.previewSrc,
mediaId: thumb.dataset.mediaId,
mediaType: thumb.dataset.mediaType || 'image',
videoSources,
image: thumb.dataset.previewSrc,
srcset: thumb.dataset.previewSrcset,
zoom: thumb.dataset.zoomSrc || thumb.dataset.previewSrc,
zoomSrcset: thumb.dataset.zoomSrcset || thumb.dataset.previewSrcset,
alt: thumb.dataset.previewAlt || ''
};
};

const activateThumb = (thumb, shouldSwapImage = true) => {
if (!thumb || thumb.hidden) return;

thumbs.forEach((item) => {
const isActive = item === thumb;
item.classList.toggle('is-active', isActive);
item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
});

if (shouldSwapImage) {
setMainMedia(getThumbMediaItem(thumb));
}

syncThumbControls('ensure-active');
};

const createThumb = (item, index) => {
const mediaId = item.mediaId || item.id || item.image;
const button = document.createElement('button');
button.className = 'yv-thumb';
button.type = 'button';
button.setAttribute('data-yv-thumb', '');
button.dataset.mediaId = mediaId ? String(mediaId) : '';
button.dataset.mediaType = item.mediaType || 'image';
button.dataset.videoSources = JSON.stringify(item.videoSources || []);
button.dataset.galleryIndex = String(index);
button.dataset.variantIds = Array.isArray(item.variantIds) ? item.variantIds.join('|') : (item.variantIds || '');
button.dataset.previewSrc = item.image || '';
button.dataset.previewSrcset = item.srcset || '';
button.dataset.zoomSrc = item.zoom || item.image || '';
button.dataset.zoomSrcset = item.zoomSrcset || item.srcset || '';
button.dataset.previewAlt = item.alt || '';
button.setAttribute(
'aria-label',
`${item.mediaType === 'video' ? 'Play' : 'View'} ${item.alt || root.dataset.productTitle || 'product'} media ${index + 1}`
);
button.setAttribute('aria-pressed', 'false');
button.setAttribute('aria-hidden', 'false');

const image = document.createElement('img');
image.loading = 'lazy';
image.decoding = 'async';
image.src = item.thumb || item.image;
if (item.thumbSrcset || item.srcset) {
image.srcset = item.thumbSrcset || item.srcset;
}
image.sizes = '96px';
image.alt = item.alt || '';
button.appendChild(image);

if (item.mediaType === 'video') {
const badge = document.createElement('span');
badge.className = 'yv-thumb-video-badge';
badge.setAttribute('aria-hidden', 'true');
badge.innerHTML = '&#9654;';
button.appendChild(badge);
}

return button;
};

const renderThumbItems = (items, activeMediaId) => {
if (!thumbRail || !items.length) {
activeGalleryItems = [];
return false;
}

activeGalleryItems = items.filter((item) => item && item.image);
thumbRail.textContent = '';
thumbs = activeGalleryItems.map(createThumb);
const fragment = document.createDocumentFragment();
thumbs.forEach((thumb) => fragment.appendChild(thumb));
thumbRail.appendChild(fragment);

if (!thumbs.length) return false;

const activeThumb = thumbs.find((thumb) => {
return activeMediaId && thumb.dataset.mediaId === String(activeMediaId);
}) || thumbs[0];

activateThumb(activeThumb, true);
return true;
};

const mobileThumbMediaQuery = window.matchMedia('(max-width: 749px)');
const isMobileThumbLayout = () => mobileThumbMediaQuery.matches;
root.classList.toggle('yv-mobile-gallery-active', isMobileThumbLayout());

const getNumericStyle = (element, property, fallback = 0) => {
if (!element) return fallback;

const value = window.getComputedStyle(element).getPropertyValue(property);
const parsed = Number.parseFloat(value);
return Number.isFinite(parsed) ? parsed : fallback;
};

const getThumbGap = () => {
if (!thumbRail) return 0;

return getNumericStyle(thumbRail, 'column-gap', getNumericStyle(thumbRail, 'gap', 0));
};

const getActiveThumbIndex = () => {
return Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
};

const clamp = (value, min, max) => {
return Math.min(Math.max(value, min), max);
};

const zoomMinimum = 1;
const zoomMaximum = 4;
const zoomStep = 0.5;
const swipeThreshold = 48;
const swipeRatio = 1.35;
const mainZoomState = { scale: 1, appliedScale: 1, x: 0, y: 0, bounds: null };
const lightboxZoomState = { scale: 1, appliedScale: 1, x: 0, y: 0, bounds: null };

const createGestureState = () => ({
pointers: new Map(),
singleStart: null,
startDistance: 0,
startMidpoint: null,
startScale: 1,
startX: 0,
startY: 0,
isPinching: false,
didMove: false
});

const mainGestureState = createGestureState();
const lightboxGestureState = createGestureState();

const getPointerPoint = (event) => ({
x: event.clientX,
y: event.clientY
});

const getGesturePoints = (gesture) => Array.from(gesture.pointers.values());

const getDistance = (firstPoint, secondPoint) => {
return Math.hypot(secondPoint.x - firstPoint.x, secondPoint.y - firstPoint.y);
};

const getMidpoint = (firstPoint, secondPoint) => ({
x: (firstPoint.x + secondPoint.x) / 2,
y: (firstPoint.y + secondPoint.y) / 2
});

const invalidateZoomBounds = (state) => {
state.bounds = null;
};

const getZoomBounds = (state, surface, image) => {
if (state.bounds) return state.bounds;

const surfaceRect = surface.getBoundingClientRect();
const imageRect = image.getBoundingClientRect();
const appliedScale = Math.max(state.appliedScale || zoomMinimum, zoomMinimum);
state.bounds = {
surfaceWidth: surfaceRect.width,
surfaceHeight: surfaceRect.height,
baseWidth: imageRect.width / appliedScale,
baseHeight: imageRect.height / appliedScale
};

return state.bounds;
};

const clampZoomPan = (state, surface, image) => {
state.scale = clamp(state.scale, zoomMinimum, zoomMaximum);

if (state.scale <= 1.01 || !surface || !image) {
state.scale = zoomMinimum;
state.x = 0;
state.y = 0;
return;
}

const bounds = getZoomBounds(state, surface, image);
const maxX = Math.max(0, ((bounds.baseWidth * state.scale) - bounds.surfaceWidth) / 2);
const maxY = Math.max(0, ((bounds.baseHeight * state.scale) - bounds.surfaceHeight) / 2);

state.x = clamp(state.x, -maxX, maxX);
state.y = clamp(state.y, -maxY, maxY);
};

const setStyleProperty = (element, property, value) => {
if (element.style.getPropertyValue(property) !== value) {
element.style.setProperty(property, value);
}
};

const updateLightboxZoomControls = () => {
const isZoomed = lightboxZoomState.scale > zoomMinimum;

if (lightboxZoomOut) lightboxZoomOut.disabled = !isZoomed;
if (lightboxZoomReset) lightboxZoomReset.disabled = !isZoomed;
if (lightboxZoomIn) lightboxZoomIn.disabled = lightboxZoomState.scale >= zoomMaximum;
};

const applyMainZoomState = () => {
if (!mainCard || !mainImage) return;

clampZoomPan(mainZoomState, mainCard, mainImage);
setStyleProperty(mainCard, '--yv-main-zoom', String(mainZoomState.scale));
setStyleProperty(mainCard, '--yv-main-pan-x', `${Math.round(mainZoomState.x)}px`);
setStyleProperty(mainCard, '--yv-main-pan-y', `${Math.round(mainZoomState.y)}px`);
mainCard.classList.toggle('is-zoomed', mainZoomState.scale > zoomMinimum);
mainZoomState.appliedScale = mainZoomState.scale;
};

const applyLightboxZoomState = () => {
if (!lightbox || !lightboxFigure || !lightboxImage) return;

clampZoomPan(lightboxZoomState, lightboxFigure, lightboxImage);
setStyleProperty(lightbox, '--yv-lightbox-zoom', String(lightboxZoomState.scale));
setStyleProperty(lightbox, '--yv-lightbox-pan-x', `${Math.round(lightboxZoomState.x)}px`);
setStyleProperty(lightbox, '--yv-lightbox-pan-y', `${Math.round(lightboxZoomState.y)}px`);
lightboxFigure.classList.toggle('is-zoomed', lightboxZoomState.scale > zoomMinimum);
updateLightboxZoomControls();
lightboxZoomState.appliedScale = lightboxZoomState.scale;
};

const resetMainZoom = () => {
mainZoomState.scale = zoomMinimum;
mainZoomState.appliedScale = zoomMinimum;
mainZoomState.x = 0;
mainZoomState.y = 0;
if (mainCard) mainCard.classList.remove('is-interacting', 'is-panning');
applyMainZoomState();
};

const resetLightboxZoom = () => {
lightboxZoomState.scale = zoomMinimum;
lightboxZoomState.appliedScale = zoomMinimum;
lightboxZoomState.x = 0;
lightboxZoomState.y = 0;
if (lightboxFigure) lightboxFigure.classList.remove('is-interacting', 'is-panning');
applyLightboxZoomState();
};

const setLightboxZoom = (scale) => {
invalidateZoomBounds(lightboxZoomState);
lightboxZoomState.scale = scale;
applyLightboxZoomState();
};

const moveMainGallery = (direction) => {
const visibleThumbs = thumbs.filter((thumb) => !thumb.hidden);
if (visibleThumbs.length < 2) return;

const activeIndex = Math.max(0, visibleThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
const nextIndex = (activeIndex + direction + visibleThumbs.length) % visibleThumbs.length;
activateThumb(visibleThumbs[nextIndex], true);
};

const beginImageGesture = (gesture, state, surface, event) => {
if (!surface || (event.pointerType === 'mouse' && event.button !== 0)) return;

invalidateZoomBounds(state);

const startedOnVideo = event.target instanceof Element && Boolean(event.target.closest('video'));
if (!startedOnVideo && typeof surface.setPointerCapture === 'function') {
try {
  surface.setPointerCapture(event.pointerId);
} catch (error) {
}
}

gesture.pointers.set(event.pointerId, getPointerPoint(event));
gesture.didMove = false;

const points = getGesturePoints(gesture);
if (points.length === 1) {
gesture.singleStart = points[0];
gesture.startX = state.x;
gesture.startY = state.y;
} else if (points.length >= 2) {
const firstPoint = points[0];
const secondPoint = points[1];
gesture.isPinching = true;
gesture.startDistance = Math.max(1, getDistance(firstPoint, secondPoint));
gesture.startMidpoint = getMidpoint(firstPoint, secondPoint);
gesture.startScale = state.scale;
gesture.startX = state.x;
gesture.startY = state.y;
surface.classList.add('is-interacting');
event.preventDefault();
}
};

const moveImageGesture = ({ gesture, state, surface, event, apply, canSwipe, onSwipeStart }) => {
if (!gesture.pointers.has(event.pointerId)) return;

gesture.pointers.set(event.pointerId, getPointerPoint(event));
const points = getGesturePoints(gesture);

if (points.length >= 2) {
const firstPoint = points[0];
const secondPoint = points[1];
const midpoint = getMidpoint(firstPoint, secondPoint);
const distance = Math.max(1, getDistance(firstPoint, secondPoint));

state.scale = gesture.startScale * (distance / Math.max(1, gesture.startDistance));
state.x = gesture.startX + (midpoint.x - gesture.startMidpoint.x);
state.y = gesture.startY + (midpoint.y - gesture.startMidpoint.y);
gesture.didMove = true;
surface.classList.add('is-interacting');
apply();
event.preventDefault();
return;
}

if (!points.length || !gesture.singleStart) return;

const point = points[0];
const deltaX = point.x - gesture.singleStart.x;
const deltaY = point.y - gesture.singleStart.y;

if (state.scale > zoomMinimum) {
state.x = gesture.startX + deltaX;
state.y = gesture.startY + deltaY;
gesture.didMove = true;
surface.classList.add('is-interacting', 'is-panning');
apply();
event.preventDefault();
return;
}

if (canSwipe() && Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
gesture.didMove = true;
if (typeof onSwipeStart === 'function') onSwipeStart();
event.preventDefault();
}
};

const endImageGesture = ({ gesture, state, surface, event, apply, canSwipe, onSwipe, onGestureEnd }) => {
if (!gesture.pointers.has(event.pointerId)) return;

const endPoint = getPointerPoint(event);
const startPoint = gesture.singleStart;
const wasPinching = gesture.isPinching;
const shouldSwipe = Boolean(
!wasPinching &&
state.scale <= zoomMinimum &&
startPoint &&
canSwipe() &&
Math.abs(endPoint.x - startPoint.x) >= swipeThreshold &&
Math.abs(endPoint.x - startPoint.x) > Math.abs(endPoint.y - startPoint.y) * swipeRatio
);

gesture.pointers.delete(event.pointerId);

if (shouldSwipe) {
if (typeof onSwipe === 'function') onSwipe(endPoint.x > startPoint.x ? -1 : 1);
event.preventDefault();
}

const points = getGesturePoints(gesture);
if (points.length === 1) {
gesture.singleStart = points[0];
gesture.startX = state.x;
gesture.startY = state.y;
gesture.startScale = state.scale;
gesture.isPinching = false;
} else if (!points.length) {
gesture.singleStart = null;
gesture.startMidpoint = null;
gesture.isPinching = false;
surface.classList.remove('is-interacting', 'is-panning');
apply();
}

if (typeof onGestureEnd === 'function') onGestureEnd(gesture.didMove || shouldSwipe || wasPinching);
};

const cancelImageGesture = (gesture, surface, event, apply) => {
if (gesture.pointers.has(event.pointerId)) {
gesture.pointers.delete(event.pointerId);
}

if (!gesture.pointers.size) {
gesture.singleStart = null;
gesture.startMidpoint = null;
gesture.isPinching = false;
surface.classList.remove('is-interacting', 'is-panning');
apply();
}
};

const getCurrentGalleryItems = () => {
if (activeGalleryItems.length) return activeGalleryItems;

return thumbs.map((thumb) => {
const image = thumb.querySelector('img');
const item = getThumbMediaItem(thumb);
return {
  id: thumb.dataset.mediaId || thumb.dataset.previewSrc,
  mediaId: thumb.dataset.mediaId,
  mediaType: item && item.mediaType || 'image',
  videoSources: item && item.videoSources || [],
  image: thumb.dataset.previewSrc,
  srcset: thumb.dataset.previewSrcset,
  zoom: thumb.dataset.zoomSrc || thumb.dataset.previewSrc,
  zoomSrcset: thumb.dataset.zoomSrcset || thumb.dataset.previewSrcset,
  thumb: image ? image.currentSrc || image.src : thumb.dataset.previewSrc,
  thumbSrcset: image ? image.srcset : '',
  alt: thumb.dataset.previewAlt || ''
};
}).filter((item) => item && item.image);
};

const focusWithoutScroll = (element) => {
if (!element || typeof element.focus !== 'function') return;

try {
element.focus({ preventScroll: true });
} catch (error) {
element.focus();
}
};

const getLightboxFocusable = () => {
if (!lightbox) return [];

return Array.from(lightbox.querySelectorAll([
'a[href]',
'area[href]',
'button:not([disabled])',
'input:not([disabled])',
'select:not([disabled])',
'textarea:not([disabled])',
'[tabindex]:not([tabindex="-1"])'
].join(','))).filter((element) => {
return element.getAttribute('aria-hidden') !== 'true' && (element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement);
});
};

const syncLightboxImageBounds = () => {
if (!lightbox || lightbox.hidden || !lightboxImage) return;

const boundsElement = lightboxFigure || lightboxStage;
if (!boundsElement) return;

const bounds = boundsElement.getBoundingClientRect();
const maxWidth = Math.max(1, Math.floor(bounds.width));
const maxHeight = Math.max(1, Math.floor(bounds.height));

setStyleProperty(lightbox, '--yv-lightbox-image-max-width', `${maxWidth}px`);
setStyleProperty(lightbox, '--yv-lightbox-image-max-height', `${maxHeight}px`);
invalidateZoomBounds(lightboxZoomState);
applyLightboxZoomState();
};

let lightboxBoundsFrame = null;
const scheduleLightboxImageBounds = () => {
if (lightboxBoundsFrame !== null) return;

lightboxBoundsFrame = window.requestAnimationFrame(() => {
lightboxBoundsFrame = null;
syncLightboxImageBounds();
});
};

const syncLightboxThumbs = () => {
if (!lightboxThumbs) return;

Array.from(lightboxThumbs.querySelectorAll('[data-yv-lightbox-thumb]')).forEach((button, index) => {
const isActive = index === lightboxIndex;
button.classList.toggle('is-active', isActive);
button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
if (isActive) button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
});
};

const setLightboxIndex = (index, shouldSyncProductImage = true) => {
const items = lightboxItems.length ? lightboxItems : getCurrentGalleryItems();
if (!items.length || !lightboxImage) return;

lightboxIndex = clamp(index, 0, items.length - 1);
const item = items[lightboxIndex];
const zoomSrc = item.zoom || item.image;
const zoomSrcset = item.zoomSrcset || item.srcset || '';

invalidateZoomBounds(lightboxZoomState);
lightboxImage.src = zoomSrc;
if (zoomSrcset) {
lightboxImage.srcset = zoomSrcset;
} else {
lightboxImage.removeAttribute('srcset');
}
lightboxImage.sizes = 'min(96vw, 1500px)';
lightboxImage.alt = item.alt || '';
resetLightboxZoom();

if (lightboxCaption) lightboxCaption.textContent = item.alt || '';
if (lightboxCount) lightboxCount.textContent = `${lightboxIndex + 1} / ${items.length}`;

[lightboxPrev, lightboxNext].forEach((button) => {
if (!button) return;

button.disabled = items.length < 2;
button.setAttribute('aria-hidden', items.length < 2 ? 'true' : 'false');
});

syncLightboxThumbs();

if (shouldSyncProductImage) {
const matchingThumb = thumbs.find((thumb) => {
  return String(thumb.dataset.mediaId || '') === String(item.mediaId || item.id || '');
});
if (matchingThumb) activateThumb(matchingThumb, true);
}
};

const moveLightbox = (direction) => {
const items = lightboxItems.length ? lightboxItems : getCurrentGalleryItems();
if (items.length < 2) return;

const nextIndex = (lightboxIndex + direction + items.length) % items.length;
setLightboxIndex(nextIndex, true);
};

const renderLightboxThumbs = () => {
if (!lightboxThumbs) return;

const items = lightboxItems.length ? lightboxItems : getCurrentGalleryItems();
lightboxThumbs.textContent = '';
lightboxThumbs.hidden = items.length < 2;
const fragment = document.createDocumentFragment();

items.forEach((item, index) => {
const button = document.createElement('button');
button.className = 'yv-lightbox-thumb';
button.type = 'button';
button.setAttribute('data-yv-lightbox-thumb', '');
button.dataset.yvLightboxIndex = String(index);
button.setAttribute('aria-label', `View product image ${index + 1}`);
button.setAttribute('aria-pressed', index === lightboxIndex ? 'true' : 'false');

const image = document.createElement('img');
image.loading = 'lazy';
image.decoding = 'async';
image.src = item.thumb || item.image;
if (item.thumbSrcset || item.srcset) {
  image.srcset = item.thumbSrcset || item.srcset;
}
image.sizes = '64px';
image.alt = item.alt || '';

button.appendChild(image);
fragment.appendChild(button);
});

lightboxThumbs.appendChild(fragment);
};

const closeLightbox = () => {
if (!lightbox || lightbox.hidden) return;

lightbox.hidden = true;
lightboxItems = [];
document.body.classList.remove('yv-lightbox-is-open');
document.removeEventListener('keydown', handleLightboxKeydown);

if (lightboxPreviouslyFocused && document.contains(lightboxPreviouslyFocused)) {
focusWithoutScroll(lightboxPreviouslyFocused);
}
lightboxPreviouslyFocused = null;
};

const openLightbox = () => {
if (!lightbox || !lightboxImage) return;

const currentItems = getCurrentGalleryItems();
const activeThumb = thumbs.find((thumb) => thumb.classList.contains('is-active'));
const activeItem = getThumbMediaItem(activeThumb);
if (activeItem && activeItem.mediaType === 'video') return;

lightboxItems = currentItems.filter((item) => item.mediaType !== 'video');
if (!lightboxItems.length) return;

const activeLightboxIndex = lightboxItems.findIndex((item) => {
return activeItem && String(item.mediaId || item.id || '') === String(activeItem.mediaId || activeItem.id || '');
});
lightboxIndex = clamp(activeLightboxIndex < 0 ? 0 : activeLightboxIndex, 0, lightboxItems.length - 1);
lightboxPreviouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : mainCard;
lightbox.hidden = false;
document.body.classList.add('yv-lightbox-is-open');

renderLightboxThumbs();
syncLightboxImageBounds();
setLightboxIndex(lightboxIndex, false);
document.addEventListener('keydown', handleLightboxKeydown);

window.requestAnimationFrame(() => {
const preferredFocus = lightbox.querySelector('.yv-lightbox-close') || lightboxNext || lightboxPrev;
syncLightboxImageBounds();
focusWithoutScroll(preferredFocus);
syncLightboxThumbs();
});
};

const handleLightboxKeydown = (event) => {
if (!lightbox || lightbox.hidden) return;

if (event.key === 'Escape') {
event.preventDefault();
closeLightbox();
return;
}

if (event.key === 'ArrowLeft') {
event.preventDefault();
moveLightbox(-1);
return;
}

if (event.key === 'ArrowRight') {
event.preventDefault();
moveLightbox(1);
return;
}

if (event.key === '+' || event.key === '=') {
event.preventDefault();
setLightboxZoom(lightboxZoomState.scale + zoomStep);
return;
}

if (event.key === '-' || event.key === '_') {
event.preventDefault();
setLightboxZoom(lightboxZoomState.scale - zoomStep);
return;
}

if (event.key === '0') {
event.preventDefault();
resetLightboxZoom();
return;
}

if (event.key !== 'Tab') return;

const focusableElements = getLightboxFocusable();
if (!focusableElements.length) {
event.preventDefault();
return;
}

const firstElement = focusableElements[0];
const lastElement = focusableElements[focusableElements.length - 1];

if (event.shiftKey && document.activeElement === firstElement) {
event.preventDefault();
focusWithoutScroll(lastElement);
} else if (!event.shiftKey && document.activeElement === lastElement) {
event.preventDefault();
focusWithoutScroll(firstElement);
}
};

const handleMainCardPointerDown = (event) => {
beginImageGesture(mainGestureState, mainZoomState, mainCard, event);
};

const handleMainCardPointerMove = (event) => {
moveImageGesture({
gesture: mainGestureState,
state: mainZoomState,
surface: mainCard,
event,
apply: applyMainZoomState,
canSwipe: isMobileThumbLayout,
onSwipeStart: () => {
  mainCardShouldIgnoreClick = true;
}
});
};

const handleMainCardPointerUp = (event) => {
endImageGesture({
gesture: mainGestureState,
state: mainZoomState,
surface: mainCard,
event,
apply: applyMainZoomState,
canSwipe: isMobileThumbLayout,
onSwipe: moveMainGallery,
onGestureEnd: (didGesture) => {
  if (didGesture) mainCardShouldIgnoreClick = true;
}
});
};

const handleMainCardPointerCancel = (event) => {
const didImageGesture = mainGestureState.didMove || mainGestureState.isPinching;
cancelImageGesture(mainGestureState, mainCard, event, applyMainZoomState);
if (didImageGesture) mainCardShouldIgnoreClick = true;
};

const handleLightboxPointerDown = (event) => {
beginImageGesture(lightboxGestureState, lightboxZoomState, lightboxFigure, event);
};

const handleLightboxPointerMove = (event) => {
moveImageGesture({
gesture: lightboxGestureState,
state: lightboxZoomState,
surface: lightboxFigure,
event,
apply: applyLightboxZoomState,
canSwipe: isMobileThumbLayout
});
};

const handleLightboxPointerUp = (event) => {
endImageGesture({
gesture: lightboxGestureState,
state: lightboxZoomState,
surface: lightboxFigure,
event,
apply: applyLightboxZoomState,
canSwipe: isMobileThumbLayout,
onSwipe: moveLightbox
});
};

const handleLightboxPointerCancel = (event) => {
cancelImageGesture(lightboxGestureState, lightboxFigure, event, applyLightboxZoomState);
};

const handleLightboxDoubleClick = (event) => {
if (!lightbox || lightbox.hidden) return;

event.preventDefault();
if (lightboxZoomState.scale > zoomMinimum) {
resetLightboxZoom();
} else {
setLightboxZoom(2);
}
};

const updateThumbNavState = (hasOverflow, atStart = true, atEnd = true) => {
if (!thumbFrame) return;

thumbFrame.classList.toggle('has-overflow', hasOverflow);
thumbNavButtons.forEach((button) => {
const isPrevious = button.dataset.yvThumbPage === 'prev';
button.disabled = !hasOverflow || (isPrevious ? atStart : atEnd);
button.setAttribute('aria-hidden', hasOverflow ? 'false' : 'true');
});
};

const syncDesktopThumbControls = (mode) => {
if (!thumbFrame || !thumbViewport || !thumbRail || !mainCard) return;

thumbViewport.style.removeProperty('width');
thumbViewport.scrollTop = 0;
thumbFrame.style.removeProperty('height');
thumbFrame.style.removeProperty('--yv-thumb-frame-max-height');

if (getComputedStyle(thumbFrame).display === 'flex') {
desktopThumbStart = 0;
desktopVisibleThumbs = thumbs.length;
thumbRail.style.transform = 'none';
updateThumbNavState(false);
return;
}

const mainCardHeight = mainCard.getBoundingClientRect().height;
if (mainCardHeight > 0) {
const resolvedHeight = `${Math.floor(mainCardHeight)}px`;
thumbFrame.style.height = resolvedHeight;
thumbFrame.style.setProperty('--yv-thumb-frame-max-height', resolvedHeight);
}

const thumbCount = thumbs.length;
if (!thumbCount) {
desktopThumbStart = 0;
desktopVisibleThumbs = 0;
thumbRail.style.transform = 'translateY(0px)';
updateThumbNavState(false);
return;
}

const firstThumb = thumbs[0];
const thumbHeight = firstThumb.getBoundingClientRect().height || getNumericStyle(firstThumb, 'height', 78);
const gap = getThumbGap();
const totalHeight = (thumbCount * thumbHeight) + (Math.max(0, thumbCount - 1) * gap);
const hasOverflow = totalHeight > (mainCardHeight || thumbViewport.clientHeight) + 1;
thumbFrame.classList.toggle('has-overflow', hasOverflow);

if (!hasOverflow) {
desktopThumbStart = 0;
desktopVisibleThumbs = thumbCount;
thumbRail.style.transform = 'translateY(0px)';
updateThumbNavState(false);
return;
}

const viewportHeight = thumbViewport.clientHeight || Math.max(thumbHeight, mainCardHeight);
const visibleCount = clamp(Math.floor((viewportHeight + gap) / (thumbHeight + gap)), 1, thumbCount);
const maxStart = Math.max(0, thumbCount - visibleCount);
const activeIndex = getActiveThumbIndex();

desktopVisibleThumbs = visibleCount;

if (mode === 'ensure-active') {
if (activeIndex < desktopThumbStart) {
  desktopThumbStart = activeIndex;
} else if (activeIndex >= desktopThumbStart + visibleCount) {
  desktopThumbStart = activeIndex - visibleCount + 1;
}
desktopThumbStart = clamp(desktopThumbStart, 0, maxStart);
} else {
desktopThumbStart = clamp(desktopThumbStart, 0, maxStart);
}

const offset = desktopThumbStart * (thumbHeight + gap);
thumbRail.style.transform = `translateY(${-Math.round(offset)}px)`;
updateThumbNavState(true, desktopThumbStart <= 0, desktopThumbStart >= maxStart);
};

const syncMobileThumbControls = (mode) => {
if (!thumbFrame || !thumbViewport || !thumbRail) return;

thumbFrame.style.removeProperty('height');
thumbFrame.style.removeProperty('--yv-thumb-frame-max-height');
thumbViewport.scrollTop = 0;

const thumbCount = thumbs.length;
if (!thumbCount) {
updateThumbNavState(false);
return;
}

const firstThumb = thumbs[0];
const thumbWidth = firstThumb.getBoundingClientRect().width || getNumericStyle(firstThumb, 'width', 16);
const gap = getThumbGap();
const frameWidth = thumbFrame.clientWidth || root.clientWidth || window.innerWidth;
const totalWidth = (thumbCount * thumbWidth) + (Math.max(0, thumbCount - 1) * gap);
const hasOverflow = totalWidth > frameWidth + 1;

if (!hasOverflow) {
mobileThumbStart = 0;
mobileVisibleThumbs = thumbCount;
thumbViewport.style.width = `${Math.ceil(totalWidth)}px`;
thumbRail.style.transform = 'translateX(0px)';
updateThumbNavState(false);
return;
}

updateThumbNavState(true, false, false);

const navWidths = thumbNavButtons.map((button) => button.getBoundingClientRect().width || Math.max(28, thumbWidth));
const navWidth = navWidths.reduce((largest, width) => Math.max(largest, width), Math.max(28, thumbWidth));
const availableWidth = Math.max(thumbWidth, frameWidth - (navWidth * 2) - (gap * 2));
const visibleCount = clamp(Math.floor((availableWidth + gap) / (thumbWidth + gap)), 1, thumbCount);
const maxStart = Math.max(0, thumbCount - visibleCount);
const activeIndex = getActiveThumbIndex();

mobileVisibleThumbs = visibleCount;

if (mode === 'active-start') {
mobileThumbStart = clamp(activeIndex, 0, maxStart);
} else if (mode === 'active-end') {
mobileThumbStart = clamp(activeIndex - visibleCount + 1, 0, maxStart);
} else if (mode === 'ensure-active') {
if (activeIndex < mobileThumbStart) {
  mobileThumbStart = activeIndex;
} else if (activeIndex >= mobileThumbStart + visibleCount) {
  mobileThumbStart = activeIndex - visibleCount + 1;
}
mobileThumbStart = clamp(mobileThumbStart, 0, maxStart);
} else {
mobileThumbStart = clamp(mobileThumbStart, 0, maxStart);
}

const viewportWidth = (visibleCount * thumbWidth) + (Math.max(0, visibleCount - 1) * gap);
const offset = mobileThumbStart * (thumbWidth + gap);

thumbViewport.style.width = `${Math.ceil(viewportWidth)}px`;
thumbRail.style.transform = `translateX(${-Math.round(offset)}px)`;
updateThumbNavState(true, mobileThumbStart <= 0, mobileThumbStart >= maxStart);
};

let thumbSyncFrame = null;
let pendingThumbSyncMode = '';

const syncThumbControls = (mode = '') => {
if (mode === 'ensure-active' || !pendingThumbSyncMode) {
pendingThumbSyncMode = mode;
}
if (thumbSyncFrame !== null) return;

thumbSyncFrame = window.requestAnimationFrame(() => {
const scheduledMode = pendingThumbSyncMode;
thumbSyncFrame = null;
pendingThumbSyncMode = '';

if (isMobileThumbLayout()) {
  syncMobileThumbControls(scheduledMode);
} else {
  syncDesktopThumbControls(scheduledMode);
}
});
};

const moveThumbWindow = (direction) => {
if (!thumbFrame || !thumbViewport) return;

if (isMobileThumbLayout()) {
const previousStart = mobileThumbStart;
syncMobileThumbControls(direction === 'next' ? 'active-start' : 'active-end');

if (previousStart === mobileThumbStart && mobileVisibleThumbs > 0) {
  const maxStart = Math.max(0, thumbs.length - mobileVisibleThumbs);
  const nextStart = clamp(
    previousStart + (direction === 'next' ? mobileVisibleThumbs : -mobileVisibleThumbs),
    0,
    maxStart
  );
  const edgeIndex = direction === 'next'
    ? nextStart
    : Math.min(thumbs.length - 1, nextStart + mobileVisibleThumbs - 1);

  mobileThumbStart = nextStart;
  if (thumbs[edgeIndex]) {
    activateThumb(thumbs[edgeIndex], true);
  } else {
    syncMobileThumbControls();
  }
}

return;
}

if (desktopVisibleThumbs <= 0) {
syncDesktopThumbControls();
}

const maxStart = Math.max(0, thumbs.length - desktopVisibleThumbs);
desktopThumbStart = clamp(
desktopThumbStart + (direction === 'next' ? desktopVisibleThumbs : -desktopVisibleThumbs),
0,
maxStart
);
syncDesktopThumbControls();
};

let desktopWheelDelta = 0;
let desktopWheelResetTimeout = null;

const moveDesktopThumbWindowWithWheel = (event) => {
if (isMobileThumbLayout() || !thumbFrame || !thumbFrame.classList.contains('has-overflow') || !thumbs.length) return;

if (desktopVisibleThumbs <= 0) {
syncDesktopThumbControls();
}

const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
if (!delta) return;

const firstThumb = thumbs[0];
const thumbHeight = firstThumb.getBoundingClientRect().height || getNumericStyle(firstThumb, 'height', 78);
const threshold = Math.max(24, thumbHeight * 0.35);
const maxStart = Math.max(0, thumbs.length - desktopVisibleThumbs);

desktopWheelDelta += delta;
window.clearTimeout(desktopWheelResetTimeout);
desktopWheelResetTimeout = window.setTimeout(() => {
desktopWheelDelta = 0;
}, 120);

if (Math.abs(desktopWheelDelta) < threshold) {
if ((desktopWheelDelta > 0 && desktopThumbStart < maxStart) || (desktopWheelDelta < 0 && desktopThumbStart > 0)) {
  event.preventDefault();
}
return;
}

const nextStart = clamp(desktopThumbStart + (desktopWheelDelta > 0 ? 1 : -1), 0, maxStart);
desktopWheelDelta = 0;

if (nextStart === desktopThumbStart) return;

event.preventDefault();
desktopThumbStart = nextStart;
syncDesktopThumbControls();
};

const getThumbIdentity = (item) => {
return (item && (item.mediaId || item.id || item.image || item.thumb) || '')
.toString()
.split('?')[0]
.replace(/^https?:/, '')
.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|x\d+)(?=\.)/i, '')
.toLowerCase();
};

const mergeThumbItems = (...groups) => {
const seen = new Set();
return groups.reduce((items, group) => items.concat(group || []), []).filter((item) => {
if (!item || !item.image) return false;

const identity = getThumbIdentity(item);
if (identity && seen.has(identity)) return false;
if (identity) seen.add(identity);

return true;
});
};

const updateThumbVisibility = (variant) => {
const variantFeaturedThumb = variant.image
? [{
  id: variant.mediaId || `${variant.id}-featured`,
  mediaId: variant.mediaId || `${variant.id}-featured`,
  mediaType: variant.mediaType || 'image',
  videoSources: variant.videoSources || [],
  image: variant.image,
  srcset: variant.srcset,
  zoom: variant.zoom || variant.image,
  zoomSrcset: variant.zoomSrcset || variant.srcset,
  thumb: variant.image,
  thumbSrcset: variant.srcset,
  alt: variant.alt
}]
: [];

const responsiveGallery = isMobileThumbLayout() ? variant.mobileGallery : variant.gallery;
const variantGallery = Array.isArray(responsiveGallery)
? responsiveGallery.filter((item) => item && item.image)
: [];

const visibleFallbackThumbs = fallbackThumbs.filter((item) => {
const variantIds = Array.isArray(item.variantIds) ? item.variantIds.map(String) : [];
return !variantIds.length || variantIds.includes(String(variant.id));
});

return renderThumbItems(mergeThumbItems(variantFeaturedThumb, visibleFallbackThumbs, variantGallery), variant.mediaId);
};

const syncBundleSelectionState = (shouldRefreshPurchase = true) => {
if (!bundleSelector) return;

const selectedBundleOption = getSelectedBundleOption();
bundleOptions.forEach((bundleOption) => {
const isSelected = bundleOption === selectedBundleOption;
const panel = bundleOption.querySelector('[data-yv-bundle-panel]');

bundleOption.classList.toggle('is-selected', isSelected);
if (panel) panel.hidden = !isSelected;
getBundleFlavorSelects(bundleOption).forEach((select) => {
  select.disabled = !isSelected;
  updateBundleFlavorColor(select);
});
updateBundleOptionQuantityCopy(bundleOption);
});

if (qtyInput) {
qtyInput.value = selectedBundleOption
  ? String(getBundleOptionQuantity(selectedBundleOption))
  : '1';
}

if (shouldRefreshPurchase) {
const variant = getSelectedVariant() || getBundleOptionVariants(selectedBundleOption)[0];
if (variant) updatePurchaseState(variant);
}
};

const updatePurchaseState = (variant) => {
if (variantSelect && variantSelect.value !== String(variant.id)) {
variantSelect.value = String(variant.id);
}

const selectedBundleOption = getSelectedBundleOption();
const isAwcPurchase = Boolean(bundleSelector && selectedBundleOption && activePurchaseSource === 'awc');
const isAppstlePurchase = Boolean(bundleSelector && activePurchaseSource === 'appstle');
const purchaseIsSoldOut = !variant.available
|| (isAwcPurchase && !isBundleSelectionAvailable());
const purchaseIsAvailable = !isBundleSubmitting && (
!bundleSelector
  ? variant.available
  : (isAppstlePurchase
    ? (variant.available && hasSelectedAppstlePurchaseMode())
    : (isAwcPurchase && isBundleSelectionAvailable()))
);
const cartConflictBlocked = syncCartPurchaseConflictState();
const couponCodeRequired = couponCodeIsRequiredForAdd();
const cartItemLimitExceeded = productCartLimitWouldBeExceeded();
syncProductCartLimitControls();

if (addToCart) {
addToCart.disabled = !purchaseIsAvailable
  || cartConflictBlocked
  || couponCodeRequired
  || cartItemLimitExceeded;
if (
  purchaseIsAvailable
  && !cartConflictBlocked
  && !couponCodeRequired
  && !cartItemLimitExceeded
) {
  addToCart.removeAttribute('aria-disabled');
} else {
  addToCart.setAttribute('aria-disabled', 'true');
}
setPrimaryButtonLabel(purchaseIsSoldOut
  ? root.dataset.soldOutLabel
  : (couponCodeRequired ? couponCodeRequiredAddLabel : root.dataset.addLabel));
}

updatePriceSummary(variant);

if (buyNow) {
buyNow.disabled = cartConflictBlocked || (bundleSelector
  ? !(isAwcPurchase && purchaseIsAvailable)
  : !purchaseIsAvailable);
}
};

const refreshCurrentPurchaseState = () => {
const variant = getSelectedVariant() || variants[0] || null;
if (variant) updatePurchaseState(variant);
};

const activateAwcPurchaseMode = () => {
activePurchaseSource = 'awc';
refreshCurrentPurchaseState();
};

const activateAppstlePurchaseMode = () => {
if (isPurchaseModeSyncing) return;

activePurchaseSource = 'appstle';
refreshCurrentPurchaseState();
};

const clearPurchaseMode = () => {
if (getSelectedBundleOption()) return;

activePurchaseSource = 'none';
refreshCurrentPurchaseState();
};

const hasSelectedAppstlePurchaseMode = () => Boolean(
root.querySelector(appstleSelectedTierSelector)
|| root.querySelector(appstleSelectedSubscriptionSelector)
);

const reconcileAppstlePurchaseMode = () => {
window.clearTimeout(appstleInteractionReconcileTimeout);
appstleInteractionReconcileTimeout = window.setTimeout(() => {
if (isPurchaseModeSyncing) return;

if (hasSelectedAppstlePurchaseMode()) {
  activateAppstlePurchaseMode();
} else if (activePurchaseSource === 'appstle') {
  clearPurchaseMode();
}
}, 80);
};

const normalizePurchaseDisplayMode = (mode) => {
return mode === 'coupon' ? 'coupon' : 'appstle';
};

const updateModeToggleCopy = () => {
if (!modeToggle || !modeToggleLabel) return;
const isCouponMode = root.dataset.purchaseMode === 'coupon';
const label = isCouponMode
? (root.dataset.appstleModeLabel || 'NO PROMO CODE?\u00a0 BUY HERE.')
: (root.dataset.promoModeLabel || 'Have a Promo Code?');
modeToggleLabel.textContent = label;
modeToggle.setAttribute('aria-label', label);
modeToggle.setAttribute('aria-pressed', isCouponMode ? 'true' : 'false');
};

const selectDefaultAwcTier = () => {
if (!bundleRadios.length) return;
const radio = bundleRadios.find((bundleRadio) => bundleRadio.checked)
|| bundleRadios[0];

if (!radio.checked) {
radio.checked = true;
}
activePurchaseSource = 'awc';
syncBundleSelectionState(false);
refreshCurrentPurchaseState();
};

let appstleConfigurationTimer = null;
let appstleConfigurationSettled = false;
let userHasInteractedWithAppstle = false;

root.addEventListener('click', (e) => {
if (!e.isTrusted) return;
if (e.target.closest('#appstleVolumeDiscountContainer') || e.target.closest('.yv-bundle-selector')) {
  userHasInteractedWithAppstle = true;
  window.clearTimeout(appstleConfigurationTimer);
  appstleConfigurationTimer = null;
}
}, true);

root.addEventListener('change', (e) => {
if (!e.isTrusted) return;
if (e.target.closest('#appstleVolumeDiscountContainer') || e.target.closest('.yv-bundle-selector')) {
  userHasInteractedWithAppstle = true;
  window.clearTimeout(appstleConfigurationTimer);
  appstleConfigurationTimer = null;
}
}, true);

const configureDefaultAppstleState = () => {
window.clearTimeout(appstleConfigurationTimer);
appstleConfigurationTimer = null;
if (
  root.dataset.purchaseMode !== 'appstle'
  || appstleConfigurationSettled
  || userHasInteractedWithAppstle
) return;

activePurchaseSource = 'appstle';
const configured = typeof configureAppstleWidgetForAwc === 'function'
  && configureAppstleWidgetForAwc({
    tier: Number.parseInt(root.dataset.appstleDefaultTier, 10) || 2,
    subscribe: root.dataset.appstlePreselectSubscription === 'true',
    deliveryWeeks: Number.parseInt(root.dataset.appstleDeliveryWeeks, 10) || 3,
    initializeFlavors: true
  });

if (configured) {
  appstleConfigurationSettled = true;
}
refreshCurrentPurchaseState();
};

const beginDefaultAppstleConfiguration = () => {
window.clearTimeout(appstleConfigurationTimer);
appstleConfigurationTimer = null;
if (userHasInteractedWithAppstle) return;
configureDefaultAppstleState();
};

const getDesiredAppstleFlavorIds = () => {
const desiredTier = Number.parseInt(root.dataset.appstleDefaultTier, 10) || 2;
const currentVariant = getSelectedVariant() || variants.find((variant) => variant.available) || variants[0];
if (!currentVariant) return [];
return Array.from({ length: desiredTier }, () => String(currentVariant.id));
};

const appstleSummaryMatchesDefault = (summary) => {
if (!summary || !summary.ready) return false;
const desiredTier = Number.parseInt(root.dataset.appstleDefaultTier, 10) || 2;
const desiredSubscription = root.dataset.appstlePreselectSubscription !== 'false';
const desiredWeeks = Number.parseInt(root.dataset.appstleDeliveryWeeks, 10) || 3;
const desiredFlavorIds = getDesiredAppstleFlavorIds();
const selectedFlavorIds = Array.isArray(summary.selectedVariantIds)
? summary.selectedVariantIds.map(String)
: [];

return Number.parseInt(summary.selectedTier, 10) === desiredTier
&& Boolean(summary.subscriptionSelected) === desiredSubscription
&& (!desiredSubscription || Number.parseInt(summary.deliveryWeeks, 10) === desiredWeeks)
&& desiredFlavorIds.every((variantId, index) => selectedFlavorIds[index] === variantId);
};

const setPurchaseDisplayMode = (requestedMode, options = {}) => {
const nextMode = normalizePurchaseDisplayMode(requestedMode);
const previousMode = normalizePurchaseDisplayMode(root.dataset.purchaseMode);
root.dataset.purchaseMode = nextMode;
root.classList.toggle('yv-purchase-mode--appstle', nextMode === 'appstle');
root.classList.toggle('yv-purchase-mode--coupon', nextMode === 'coupon');
updateModeToggleCopy();

if (nextMode === 'coupon') {
window.clearTimeout(appstleConfigurationTimer);
appstleConfigurationTimer = null;
appstleConfigurationSettled = false;
activePurchaseSource = 'awc';
selectDefaultAwcTier();
scheduleDiscountCodeCookieSync('product-coupon-mode');
} else {
window.clearTimeout(appstleInteractionReconcileTimeout);
isPurchaseModeSyncing = false;
activePurchaseSource = 'appstle';
beginDefaultAppstleConfiguration();
ensureAppstleTierSelectionForAwc(readAppstleWidgetSummaryForAwc());
refreshCurrentPurchaseState();
if (options.clearCoupon && (activeDiscountPercent > 0 || activeDiscountCode || getDiscountCodeFromCookie())) {
  removeProductCouponCode();
}
}

root.dispatchEvent(new CustomEvent('yerba:purchase-mode-change', {
bubbles: true,
detail: {
  mode: nextMode,
  previousMode
}
}));
};

const isAppstlePurchaseInteraction = (target) => {
if (!target.closest(appstleVolumeDiscountSelector)) return false;

return Boolean(
target.closest(appstleTierControlSelector)
|| target.closest(appstleSubscriptionControlSelector)
|| target.closest('select, input, button')
);
};

const trackPurchaseSourceInteraction = (event) => {
if (isPurchaseModeSyncing) return;
if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;

const target = event.target;
if (!target || typeof target.closest !== 'function') return;

const isCouponPurchaseMode = root.dataset.purchaseMode === 'coupon';

if (!isCouponPurchaseMode && isAppstlePurchaseInteraction(target)) {
activateAppstlePurchaseMode();
reconcileAppstlePurchaseMode();
return;
}

const awcBundleControl = target.closest('[data-yv-bundle-option]');
const awcBuyNowControl = target.closest('[data-yv-buy-now]');
const awcSubmitControl = target.closest('[data-yv-atc]');
if (
isCouponPurchaseMode
&& (awcBundleControl || ((awcBuyNowControl || awcSubmitControl) && getSelectedBundleOption()))
) {
activateAwcPurchaseMode();
}
};

['keydown', 'click', 'change'].forEach((eventName) => {
root.addEventListener(eventName, trackPurchaseSourceInteraction, true);
});

document.addEventListener('appstleBundlesAppliedVolumeDiscount', (event) => {
if (isPurchaseModeSyncing) return;

const detail = event.detail;
const eventProductId = detail && detail.productId != null ? String(detail.productId) : '';
if (eventProductId && root.dataset.productId && eventProductId !== root.dataset.productId) return;

if (detail) {
if (activePurchaseSource === 'awc' && getSelectedBundleOption()) {
  return;
}

activateAppstlePurchaseMode();
return;
}

reconcileAppstlePurchaseMode();
});

let displayedGalleryVariant = null;

const selectVariant = (variantId, shouldUpdateUrl = false, shouldUpdatePurchase = true) => {
const variant = variantsById.get(String(variantId));
if (!variant) return;

displayedGalleryVariant = variant;

const optionValue = variant.options[optionIndex] || variant.title;

const flavorColor = getFlavorColor(optionValue, variant.id);
root.style.setProperty('--yv-current-flavor-bg', flavorColor);
root.style.setProperty('--yv-bundle-flavor-color', flavorColor);
root.style.setProperty('--yv-mobile-reference-green', getMobileForegroundColor(optionValue, variant.id));

variantCards.forEach((card) => {
const isActive = normalize(card.dataset.optionValue) === normalize(optionValue);
card.classList.toggle('is-active', isActive);
card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
});

if (selectedTitle) selectedTitle.textContent = variantHeadingTitles.get(optionValue) || optionValue;
updateSelectedDescription(variant);
setSelectedBackground(optionValue);
if (!updateThumbVisibility(variant)) {
setMainImage(variant.image, variant.srcset, variant.alt);
}
if (shouldUpdatePurchase) updatePurchaseState(variant);
updateMobileHeroHeight();

if (shouldUpdateUrl && window.history && window.history.replaceState) {
const url = new URL(window.location.href);
url.searchParams.set('variant', variant.id);
window.history.replaceState({}, '', url.toString());
}
};

variantCards.forEach((card) => {
card.style.setProperty('--yv-card-bg', getColorForOption(card.dataset.optionValue));
card.addEventListener('click', () => {
if (isBundleSubmitting) return;
selectVariant(card.dataset.variantId, false, false);
});
});

if (thumbRail) {
thumbRail.addEventListener('click', (event) => {
const thumb = event.target.closest('[data-yv-thumb]');
if (thumb && thumbRail.contains(thumb)) activateThumb(thumb, true);
});
}

thumbNavButtons.forEach((button) => {
button.addEventListener('click', () => moveThumbWindow(button.dataset.yvThumbPage));
});

if (mainCard) {
mainCard.addEventListener('pointerdown', handleMainCardPointerDown);
mainCard.addEventListener('pointermove', handleMainCardPointerMove);
mainCard.addEventListener('pointerup', handleMainCardPointerUp);
mainCard.addEventListener('pointercancel', handleMainCardPointerCancel);
mainCard.addEventListener('click', (event) => {
if (mainCardShouldIgnoreClick) {
  event.preventDefault();
  event.stopPropagation();
  mainCardShouldIgnoreClick = false;
  return;
}

if (mainVideoHost && !mainVideoHost.hidden) return;

openLightbox();
});
mainCard.addEventListener('keydown', (event) => {
if ((event.key !== 'Enter' && event.key !== ' ') || (mainVideoHost && !mainVideoHost.hidden)) return;

event.preventDefault();
openLightbox();
});
}

lightboxCloseButtons.forEach((button) => {
button.addEventListener('click', closeLightbox);
});

if (lightboxPrev) {
lightboxPrev.addEventListener('click', () => moveLightbox(-1));
}

if (lightboxNext) {
lightboxNext.addEventListener('click', () => moveLightbox(1));
}

if (lightboxZoomIn) {
lightboxZoomIn.addEventListener('click', () => setLightboxZoom(lightboxZoomState.scale + zoomStep));
}

if (lightboxZoomOut) {
lightboxZoomOut.addEventListener('click', () => setLightboxZoom(lightboxZoomState.scale - zoomStep));
}

if (lightboxZoomReset) {
lightboxZoomReset.addEventListener('click', resetLightboxZoom);
}

if (lightboxFigure) {
lightboxFigure.addEventListener('pointerdown', handleLightboxPointerDown);
lightboxFigure.addEventListener('pointermove', handleLightboxPointerMove);
lightboxFigure.addEventListener('pointerup', handleLightboxPointerUp);
lightboxFigure.addEventListener('pointercancel', handleLightboxPointerCancel);
lightboxFigure.addEventListener('dblclick', handleLightboxDoubleClick);
}

if (lightboxThumbs) {
lightboxThumbs.addEventListener('click', (event) => {
const thumb = event.target.closest('[data-yv-lightbox-thumb]');
if (!thumb || !lightboxThumbs.contains(thumb)) return;

const index = Number.parseInt(thumb.dataset.yvLightboxIndex, 10);
if (Number.isFinite(index)) setLightboxIndex(index, true);
});
}

if (thumbViewport) {
thumbViewport.addEventListener('scroll', () => syncThumbControls(), { passive: true });
}

if (thumbFrame) {
thumbFrame.addEventListener('wheel', moveDesktopThumbWindowWithWheel, { passive: false });
}

window.addEventListener('resize', () => {
invalidateZoomBounds(mainZoomState);
const selectedVariant = displayedGalleryVariant || getSelectedVariant();
if (selectedVariant && isMobileThumbLayout() !== root.classList.contains('yv-mobile-gallery-active')) {
root.classList.toggle('yv-mobile-gallery-active', isMobileThumbLayout());
updateThumbVisibility(selectedVariant);
}
syncThumbControls('ensure-active');
scheduleLightboxImageBounds();
});

if ('ResizeObserver' in window) {
const thumbResizeObserver = new ResizeObserver(() => {
invalidateZoomBounds(mainZoomState);
syncThumbControls('ensure-active');
});
if (mainCard) thumbResizeObserver.observe(mainCard);

const lightboxBoundsObserver = new ResizeObserver(scheduleLightboxImageBounds);
if (lightboxFigure) lightboxBoundsObserver.observe(lightboxFigure);
}

if (mainImage) {
mainImage.addEventListener('load', () => invalidateZoomBounds(mainZoomState));
}

if (lightboxImage) {
lightboxImage.addEventListener('load', () => {
invalidateZoomBounds(lightboxZoomState);
scheduleLightboxImageBounds();
});
}

applyMainZoomState();
updateLightboxZoomControls();

bundleRadios.forEach((radio) => {
radio.addEventListener('change', () => {
if (!radio.checked) return;

setCouponMessage('');
activateAwcPurchaseMode();
syncBundleSelectionState(false);
scheduleDiscountCodeCookieSync('product-awc-selection');
const variant = getSelectedVariant();
if (variant) updatePurchaseState(variant);
});
});

if (bundleSelector) {
bundleSelector.addEventListener('change', (event) => {
const select = event.target.closest('[data-yv-bundle-flavor-select]');
if (!select || !bundleSelector.contains(select)) return;
updateBundleFlavorColor(select);
const variant = getSelectedVariant();
if (variant) updatePurchaseState(variant);
});

bundleSelector.addEventListener('click', (event) => {
const quantityButton = event.target.closest('[data-yv-bundle-quantity-change]');
if (!quantityButton || !bundleSelector.contains(quantityButton)) return;

event.preventDefault();
event.stopPropagation();
const bundleOption = quantityButton.closest('[data-yv-bundle-option]');
if (!bundleOption) return;
const delta = Number.parseInt(quantityButton.dataset.yvBundleQuantityChange, 10) || 0;
setBundleOptionQuantity(bundleOption, getBundleOptionQuantity(bundleOption) + delta);
});
}

if (bundleSelector) {
bundleRadios.forEach((radio) => {
radio.checked = false;
});
initializeBundleFlavorDefaults();
syncBundleSelectionState(false);
} else if (qtyInput) {
['change', 'input'].forEach((eventName) => {
qtyInput.addEventListener(eventName, () => {
  const variant = variantsById.get(String(variantSelect && variantSelect.value));
  if (variant) updatePurchaseState(variant);
});
});
}

if (couponInput) {
couponInput.addEventListener('keydown', (event) => {
if (event.key !== 'Enter') return;

event.preventDefault();
applyProductCouponCode();
});
}

if (couponApply) {
couponApply.addEventListener('click', applyProductCouponCode);
}

if (couponRemove) {
couponRemove.addEventListener('click', removeProductCouponCode);
}

if (modeToggle) {
modeToggle.addEventListener('click', () => {
const isCouponMode = root.dataset.purchaseMode === 'coupon';
setPurchaseDisplayMode(isCouponMode ? 'appstle' : 'coupon', {
  clearCoupon: isCouponMode
});
});
}

if (variantSelect) {
variantSelect.addEventListener('change', () => selectVariant(variantSelect.value, true));
const initialBundleVariant = bundleSelector
? getBundleOptionVariants(getSelectedBundleOption())[0]
: null;
selectVariant(
(initialBundleVariant && initialBundleVariant.id) || variantSelect.value || yvConfig.currentVariantId,
false
);
} else if (variants.length) {
selectVariant(yvConfig.currentVariantId, false);
}

/* The flavor cards in the info-columns section use ordinary Shopify product
   forms. Attach the same Appstle return context as this visual product form so
   the Cart can turn those lines into real volume-discount/subscription lines. */
const syncInfoColumnAppstleReturnContext = (targetForm = null) => {
const appstleReturnContext = getAppstleReturnContextForAwc(
  targetForm ? new FormData(targetForm) : (productForm ? new FormData(productForm) : null)
);
if (!appstleReturnContext) return false;

const forms = targetForm
  ? [targetForm]
  : Array.from(document.querySelectorAll('.info-cols--cart-form'));
forms.forEach((form) => {
  const variantField = form.querySelector('[name="id"]');
  const variantId = variantField ? String(variantField.value || '') : '';
  if (!variantId || !variantsById.has(variantId)) return;

  setProductFormFieldValue(
    form,
    `properties[${appstleReturnContextPropertyName}]`,
    JSON.stringify(appstleReturnContext)
  );
});
return true;
};

document.addEventListener('submit', (event) => {
const infoColumnForm = event.target && event.target.closest
  ? event.target.closest('.info-cols--cart-form')
  : null;
if (infoColumnForm) syncInfoColumnAppstleReturnContext(infoColumnForm);
}, true);

if (typeof observeAppstleWidgetForAwc === 'function') {
observeAppstleWidgetForAwc((summary) => {
if (root.dataset.purchaseMode !== 'appstle') return;

activePurchaseSource = 'appstle';
ensureAppstleTierSelectionForAwc(summary);
if (summary && summary.ready) {
  restoreAppstleDeliveryIntervalForAwc(summary);
  restoreAppstleFlavorSelectionsForAwc(summary);
  syncAppstlePresentationForAwc(summary);
  syncProductCartLimitControls(summary);
  if (!appstleConfigurationSettled && !userHasInteractedWithAppstle) {
    configureDefaultAppstleState();
  }
  if (productForm) {
    syncSingleOrIdenticalAppstleSelectionToForm(productForm);
  }
  /* Persist the current native bundle properties and delivery plan before any
     secondary product form can navigate away from this page. */
  syncInfoColumnAppstleReturnContext();
  refreshCurrentPurchaseState();
}
});
}

const initialPurchaseMode = shouldDefaultToCouponPurchaseMode()
? 'coupon'
: (root.dataset.defaultPurchaseMode || 'appstle');
setPurchaseDisplayMode(initialPurchaseMode);
updateMobileHeroHeight();

refreshCartDiscountState();
scheduleDiscountCodeCookieSync('product-cookie-initial');

window.addEventListener('klaviyoForms', (event) => {
const detail = event.detail || {};
if (!isKlaviyoSignupSuccessEvent(detail) || !isCouponKlaviyoFormEvent(detail)) return;

markCouponEligibleForSession();
scheduleDiscountCodeCookieSync('product-klaviyo-form');
setPurchaseDisplayMode('coupon');
refreshPriceForCouponEligibility();
});

document.addEventListener('yerba:newsletter-coupon-eligible', () => {
markCouponEligibleForSession();
scheduleDiscountCodeCookieSync('product-newsletter-eligible');
setPurchaseDisplayMode('coupon');
refreshPriceForCouponEligibility();
});

document.addEventListener('yerba:discount-state-changed', refreshPriceForCouponEligibility);

if (productForm) {
productForm.addEventListener('submit', handleAddToCartSubmit, Boolean(bundleSelector));
}

window.addEventListener('pageshow', (event) => {
/* A successful Coupon-mode add redirects to Cart while the form is inert. If
   the shopper returns with the browser Back button, the back-forward cache can
   restore that exact busy DOM and JavaScript state. Reset transient submission
   state and re-read the cart so the restored product page is interactive and
   reflects any cart edits made while it was away. */
if (!event.persisted) return;

isBundleSubmitting = false;
if (productForm) {
  if ('inert' in productForm) productForm.inert = false;
  productForm.removeAttribute('aria-busy');
}
bundleRadios.forEach((radio) => { radio.disabled = false; });
syncBundleSelectionState(false);
if (addToCart) addToCart.removeAttribute('aria-busy');
if (buyNow) buyNow.removeAttribute('aria-busy');
refreshCurrentPurchaseState();
refreshCartDiscountState();
});

if (buyNow) {
buyNow.addEventListener('click', async () => {
activePurchaseSource = 'awc';
if (productCartLimitWouldBeExceeded()) {
  syncProductCartLimitControls();
  const currentVariant = getSelectedVariant();
  if (currentVariant) updatePurchaseState(currentVariant);
  return;
}
const form = productForm;
if (!form) return;
if (bundleSelector && isBundleSubmitting) return;

const bundleLines = bundleSelector ? getSelectedBundleLines() : [];
const formData = new FormData(form);
let sharedBundleAttributes = null;
if (!bundleSelector) clearAppstleBundleContext();
const variantId = formData.get('id') || (variantSelect && variantSelect.value);
if (bundleSelector && (!bundleLines.length || !isBundleSelectionAvailable())) return;
if (!bundleSelector && !variantId) return;

let isNavigating = false;
buyNow.disabled = true;
buyNow.setAttribute('aria-busy', 'true');
if (bundleSelector) {
  isBundleSubmitting = true;
  if ('inert' in form) form.inert = true;
  form.setAttribute('aria-busy', 'true');
  bundleRadios.forEach((radio) => { radio.disabled = true; });
  bundleFlavorSelects.forEach((select) => { select.disabled = true; });
  if (addToCart) addToCart.disabled = true;
}

try {
  if (shouldSyncCookieDiscountBeforeAdd()) {
    await applyDiscountCodeFromCookie('product-before-buy-now', { force: true });
  }

  if (bundleSelector) {
    const appstleReturnContext = await waitForAppstleReturnContextForAwc(form);
    sharedBundleAttributes = getSharedBundleLineAttributes(
      form,
      formData,
      appstleReturnContext
    );
    const needsAjaxCheckout = Boolean(sharedBundleAttributes.sellingPlan)
      || Object.keys(sharedBundleAttributes.properties).length > 0;

    if (needsAjaxCheckout) {
      await addBundleToCartWithAjax(form, bundleLines, sharedBundleAttributes);
      isNavigating = true;
      window.location.href = checkoutUrl;
    } else {
      isNavigating = true;
      window.location.href = buildBundleBuyNowUrl(bundleLines);
    }
  } else {
    isNavigating = true;
    window.location.href = buildBuyNowUrl(variantId, getCurrentQuantity());
  }
} catch (error) {
  console.warn(error);
  setAddToCartFeedback(root.dataset.addErrorLabel, getSelectedVariant(), 2600);
} finally {
  if (!isNavigating) {
    isBundleSubmitting = false;
    if ('inert' in form) form.inert = false;
    form.removeAttribute('aria-busy');
    bundleRadios.forEach((radio) => { radio.disabled = false; });
    syncBundleSelectionState(false);
    buyNow.removeAttribute('aria-busy');
    refreshCurrentPurchaseState();
  }
}
});
}
};

const initAll = (scope) => {
scope.querySelectorAll('[data-yv-visual-product]').forEach(initYerbaVisualProduct);
};
initAll(document);
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
